export default {
  'activity.addPromotionSettings': '新增优惠设置',
  'activity.editPromotionSettings': '编辑优惠设置',
  'activity.appIcon': 'App图标',
  'activity.back': '返回',
  'activity.basicSettings': '基础设置',
  'activity.batchModify': '批量修改',
  'activity.batchModifyMaxAmount': '批量修改每日最高返水金额',
  'activity.batchModifyRebate': '批量修改游戏返点',
  'activity.batchModifyTicket': '批量修改参与券',
  'activity.batchModifyTicketCount': '批量修改参与券数量',
  'activity.cannotDelete': '数据不能删除',
  'activity.cannotDeleteWithBoundTickets': '删除仅在无绑定券时使用',
  'activity.clickToUpload': '点击上传',
  'activity.copyPromotion': '复制优惠',
  'activity.currency': '币种',
  'activity.dataLoadFailed': '数据加载失败',
  'activity.deselectAll': '全部取消',
  'activity.displaySort': '显示排序',
  'activity.editCopy': '编辑文案',
  'activity.enterBatchMaxAmount': '请输入批量修改每日最高返水金额',
  'activity.enterBatchRebate': '请输入批量修改游戏返点',
  'activity.enterBetAmount': '请输入投注额(含)',
  'activity.enterDisplaySort': '请输入显示排序',
  'activity.rewardExpireDays': '奖励过期天数',
  'activity.enterRewardExpireDays': '请输入奖励过期天数（-1表示不过期）',
  'activity.rewardExpireDaysTooltip': '输入天数，-1表示不过期',
  'activity.rewardExpireDaysCannotBeZero': '奖励过期天数不能为0',
  'activity.showFlowMultiple': '流水倍数显示开关',
  'activity.showFlowMultipleOn': '开启',
  'activity.showFlowMultipleOff': '关闭',
  'activity.days': '天',
  'activity.activityIntroduction': '活动简介',
  'activity.enterActivityIntroduction': '请输入活动简介',
  'activity.activityIcon': '活动图标',
  'activity.selectActivityIcon': '请上传活动图标',
  'activity.detailUrl': '详情地址',
  'activity.enterDetailUrl': '请输入详情地址',
  'activity.enterMaxRebateAmount': '请输入最高返水金额',
  'activity.enterPromotionContent': '请输入优惠内容',
  'activity.enterPromotionName': '请输入优惠名称',
  'activity.enterRebatePercent': '请输入返水比例',
  'activity.enterTurnoverMultiple': '请输入流水倍数',
  'activity.errorParsingMultiTypeName': '解析多类型名称时出错',
  'activity.formValidationFailed': '表单验证失败',
  'activity.gamePlatform': '游戏平台',
  'activity.h5Icon': 'H5图标',
  'activity.language': '语言',
  'activity.loadingTemplate': '正在加载实时优惠模板...',
  'activity.manualSend.add': '新增',
  'activity.manualSend.back': '返回',
  'activity.manualSend.batchImport': '批量导入',
  'activity.manualSend.bonusAmount': '优惠金额',
  'activity.manualSend.bonusPoints': '优惠积分',
  'activity.manualSend.cash': '现金',
  'activity.manualSend.point': '积分',
  'activity.manualSend.ticket': '参与券',
  'activity.manualSend.confirmIssue': '确认发放',
  'activity.manualSend.search': '查询',
  'activity.manualSend.reset': '重置',
  'activity.manualSend.execute': '执行',
  'activity.manualSend.memberAccount': '会员账号',
  'activity.manualSend.enterMemberAccount': '请输入会员账号',
  'activity.confirmEnable': '确定要启用该活动吗？',
  'activity.confirmDisable': '确定要禁用该活动吗？',
  'activity.manualSend.currency': '币种',
  'activity.manualSend.dataLoadFailed': '数据加载失败',
  'activity.manualSend.downloadTemplate': '导入模板下载',
  'activity.manualSend.enterBonusAmount': '请输入优惠金额',
  'activity.manualSend.enterBonusPoints': '请输入优惠积分',
  'activity.manualSend.enterMemberName': '请输入会员名称',
  'activity.manualSend.enterTurnoverMultiple': '请输入流水倍数',
  'activity.manualSend.failCount': '失败条数',
  'activity.manualSend.importCount': '导入条数',
  'activity.manualSend.importDetails': '导入详情',
  'activity.manualSend.importStatus': '导入状态',
  'activity.manualSend.importTime': '导入时间',
  'activity.manualSend.memberName': '会员名称',
  'activity.manualSend.operationSuccess': '操作成功',
  'activity.manualSend.operationTime': '操作时间',
  'activity.manualSend.operator': '操作人',
  'activity.manualSend.promotionName': '优惠名称',
  'activity.manualSend.rewardType': '奖励类型',
  'activity.manualSend.selectCurrency': '请选择币种',
  'activity.manualSend.selectImportStatus': '请选择导入状态',
  'activity.manualSend.selectPromotionName': '请选择优惠名称',
  'activity.manualSend.selectRewardType': '请选择奖励类型',
  'activity.manualSend.successAmount': '发放成功金额',
  'activity.manualSend.successCount': '成功条数',
  'activity.manualSend.turnoverMultiple': '流水倍数',
  'activity.manualSend.uploadFile': '请上传 CSV 或 Excel 文件',
  'activity.manualSend.uploadSuccess': '新增成功',
  'activity.manualSend.usageInstructions': '使用说明',
  'activity.manualSend.instruction1': '请先下载导入模版，批量导入会员数量10万以下',
  'activity.manualSend.instruction2': '超出请分批多次上传，每5分钟最多上传一次',
  'activity.manualSend.instruction3': '上传文档的大小不超过20M',
  'activity.manualSend.view': '查看',
  'activity.manualSend.selectTicket': '请选择参与券',
  'activity.manualSend.ticketName': '参与券名称',
  'activity.manualSend.ticketNameLabel': '选择参与券',
  'activity.manualSend.batchImportSuccess': '批量导入成功',
  'activity.manualSend.templateFileName': '参与券导入模版.csv',
  'activity.manualSend.csvColumnMemberName': '会员名称',
  'activity.manualSend.csvColumnQuantity': '数量',
  'activity.manualSend.csvExampleRow': '请删除该行范例-{{memberName}},{{quantity}}',
  'activity.manualSend.fileFormat': '文件格式：CSV格式',
  'activity.manualSend.fileSize': '文件大小：不超过20MB',
  'activity.manualSend.columnFields': '列字段：会员名称,数量',
  'activity.manualSend.totalIssuedQuantity': '总发放数量',
  'activity.modifySuccess': '修改成功',
  'activity.operationSuccess': '操作成功',
  'activity.pcIcon': 'PC图标',
  'activity.promotionCategory': '优惠分类',
  'activity.promotionContent': '优惠内容',
  'activity.promotionEffectiveTime': '优惠生效时间',
  'activity.promotionName': '优惠名称',
  'activity.promotionSettings': '优惠设置',
  'activity.promotionShowTime': '优惠展示时间',
  'activity.promotionTemplate': '优惠模板',
  'activity.rebate.awardMax': '赠送最高限制',
  'activity.rebate.betAmount': '投注额(含)',
  'activity.rebate.betAmountMax': '投注额(不含)',
  'activity.rebate.betAmountMaxError': '最高投注(不含) 必须大于 投注额(含)',
  'activity.rebate.cashAmount': '现金金额',
  'activity.rebate.cashAwardMethod': '现金奖励方式',
  'activity.rebate.dailyRecharge': '每日充值',
  'activity.rebate.desireMultiple': '流水倍数',
  'activity.rebate.enterAwardMax': '请输入赠送最高限制',
  'activity.rebate.enterBetAmount': '请输入投注额(含)',
  'activity.rebate.enterBetAmountMax': '请输入投注额(不含)',
  'activity.rebate.enterCashAmount': '请输入现金金额',
  'activity.rebate.enterDailyRecharge': '请输入每日充值',
  'activity.rebate.enterDesireMultiple': '请输入流水倍数',
  'activity.rebate.enterPointAmount': '请输入积分金额',
  'activity.rebate.fixedAmount': '固定金额',
  'activity.rebate.gamePlatform': '游戏平台',
  'activity.rebate.percentage': '百分比',
  'activity.rebate.percentMaxTwoDecimals': '比例不可为负且最多支持小数点后两位',
  'activity.rebate.truncateNotice': '返水比例支持小数点后两位；现金返水金额保留2位小数，超出部分直接舍弃（不四舍五入），不足0.01的奖励将舍弃不派发；积分返水不受影响。',
  'activity.rebate.pointAmount': '积分金额',
  'activity.rebate.pointAwardMethod': '积分奖励方式',
  'activity.rebate.rebateSettings': '返水设置',
  'activity.rebate.selectCashAwardMethod': '请选择现金奖励方式',
  'activity.rebate.selectPointAwardMethod': '请选择积分奖励方式',
  'activity.save': '保存',
  'activity.saving': '正在保存...',
  'activity.selectAll': '全部选中',
  'activity.selectAppIcon': '请选择App图标',
  'activity.selectCurrency': '请选择币种',
  'activity.selectCurrencyFirst': '请先选择币种',
  'activity.selectH5Icon': '请选择H5图标',
  'activity.selectLanguage': '请选择语言',
  'activity.selectPcIcon': '请选择PC图标',
  'activity.selectPromotionCategory': '请选择优惠分类',
  'activity.selectPromotionEffectiveTime': '请选择优惠生效时间',
  'activity.selectPromotionName': '请选择优惠名称',
  'activity.selectPromotionShowTime': '请选择优惠展示时间',
  'activity.selectPromotionTemplate': '请选择优惠模板',
  'activity.selectStatus': '请选择状态',
  'activity.selectTicket': '请选择参与券',
  'activity.enterTicketCount': '请输入数量',
  'activity.setMultiLanguage': '设置多语言',
  'activity.turnoverMultiple': '流水倍数',
  'activity.type.action': '操作',
  'activity.type.add': '新增',
  'activity.type.addSuccess': '新增成功',
  'activity.type.categoryName': '优惠分类名称',
  'activity.type.confirmDelete': '是否删除',
  'activity.type.dataLoadFailed': '数据加载失败',
  'activity.type.delete': '删除',
  'activity.type.deleteSuccess': '删除成功',
  'activity.type.edit': '修改',
  'activity.type.enterCategoryName': '请输入优惠分类名称',
  'activity.type.enterRemarks': '请输入备注',
  'activity.type.enterSort': '请输入排序',
  'activity.type.formValidationFailed': '表单验证失败',
  'activity.type.language': '语言',
  'activity.type.modifySuccess': '修改成功',
  'activity.type.operationTime': '操作时间',
  'activity.type.operator': '操作人',
  'activity.type.remarks': '备注',
  'activity.type.selectLanguage': '请选择语言',
  'activity.type.setMultiLanguage': '设置多语言',
  'activity.type.sort': '排序',
  'activity.vipLevel': 'VIP{{level}}',
  'activity.welfare.amount': '优惠金额',
  'activity.welfare.cash': '现金',
  'activity.welfare.claimed': '已领取',
  'activity.welfare.claimMethod': '领取方式',
  'activity.welfare.createTime': '创建时间',
  'activity.welfare.claimTime': '领取时间',
  'activity.welfare.currency': '币种',
  'activity.welfare.dataLoadFailed': '数据加载失败',
  'activity.welfare.enterMemberAccount': '请输入会员帐号',
  'activity.welfare.expireTime': '奖励过期时间',
  'activity.welfare.pointExpireTime': '积分过期时间',
  'activity.welfare.memberAccount': '会员帐号',
  'activity.welfare.point': '积分',
  'activity.welfare.points': '优惠积分',
  'activity.welfare.promotionName': '优惠名称',
  'activity.welfare.rewardName': '奖励名称',
  'activity.welfare.selectCurrency': '请选择币种',
  'activity.welfare.selectPromotionName': '请选择优惠名称',
  'activity.welfare.selectStatus': '请选择优惠状态',
  'activity.welfare.selectSubActivityName': '请选择子活动名称',
  'activity.welfare.vipLevel': 'VIP等级',
  'activity.welfare.selectVipLevel': '请选择VIP等级',
  'activity.welfare.status': '优惠状态',
  'activity.welfare.subActivityName': '子活动名称',
  'activity.welfare.systemIssue': '系统发放',
  'activity.welfare.status.available': '待领取',
  'activity.welfare.status.received': '已领取',
  'activity.welfare.status.expired': '已过期',
  'activity.welfare.turnoverMultiple': '流水倍数',
  'activity.welfare.export': '导出',
  'activity.welfare.exportLoading': '正在导出数据...',
  'activity.welfare.exportSuccess': '导出成功',
  'activity.welfare.exportFail': '导出失败',
  'common.currency': '币种',
  'common.status': '状态',
  'activity.uploadValidFile': '请上传并解析有效的 CSV 或 Excel 文件',
  'export.serialNumber': '序號',
  'export.fileName': '文件名',
  'export.createDate': '創建日期',
  'export.status': '狀態',
  'export.operation': '操作',
  'export.status.success': '已成功',
  'export.status.processing': '處理中',
  'export.status.failed': '下载失败',
  'export.button.download': '下載',
  'export.button.delete': '刪除',
  'export.button.refresh': '刷新',
  'export.button.clearAll': '全部清除',
  'export.downloadList': '下載列表',
  'export.noData': '暫無數據',
  'activity.register.cashAmount': '现金奖励金额',
  'activity.register.cashAmountMustBeNonNegative': '现金奖励金额不能为负数',
  'activity.register.cashAmountTooltip': '用户注册时获得的现金奖励金额，最多2位小数',
  'activity.register.cashRequiresMultiple': '现金奖励大于0时需要设置流水倍数',
  'activity.register.desireMultiple': '流水倍数',
  'activity.register.desireMultipleTooltip': '现金奖励的流水倍数要求，必须为整数',
  'activity.register.enterCashAmount': '请输入现金奖励金额',
  'activity.register.enterDesireMultiple': '请输入流水倍数',
  'activity.register.enterPointAmount': '请输入积分奖励数量',
  'activity.register.note': '注意事项',
  'activity.register.noteCashDecimal': '现金奖励金额最多保留2位小数',
  'activity.register.noteCashMultiple': '现金奖励大于0时必须设置流水倍数',
  'activity.register.noteMultipleInteger': '流水倍数必须为整数',
  'activity.register.noteOnePerUser': '每个用户每个活动只能领取一次',
  'activity.register.notePointInteger': '积分奖励数量必须为整数',
  'activity.register.pointAmount': '积分奖励数量',
  'activity.register.pointAmountMustBeNonNegative': '积分奖励数量不能为负数',
  'activity.register.pointAmountTooltip': '用户注册时获得的积分奖励数量，必须为整数',
  'activity.register.promotionSettings': '注册优惠设置',
  'activity.register.ticketReward': '参与券奖励',
  'activity.register.ticket': '参与券',
  'activity.register.selectTicketTooltip': '选择赠送的参与券类型',
  'activity.register.selectTicketPlaceholder': '请选择参与券',
  'activity.register.ticketCount': '参与券数量',
  'activity.register.ticketCountRequired': '选择参与券后必须输入数量',
  'activity.register.ticketCountNonNegative': '数量不能为负数',
  'activity.register.ticketCountTooltip': '设置赠送的参与券数量',
  'activity.register.enterTicketCount': '请输入数量',
  'activity.register.addTicket': '添加参与券',
  'activity.register.spinTickets': '参与券配置',
  'activity.register.addSpinTicket': '+ 添加参与券',
  'activity.register.distributeMode': '派发方式',
  'activity.register.distributeModeDirect': '直接派发到用户账户',
  'activity.register.distributeModeDirectDesc': '首次登录时，现金入主账户、积分入积分账户、转盘次数自动发放',
  'activity.register.distributeModeCoupon': '派发至优惠中心待领取',
  'activity.register.distributeModeCouponDesc': '首次登录时，奖励出现在优惠中心，用户手动领取后到账',
  'activity.register.distributeModeNote': '两种方式均在注册后首次登录时生效，适用于导入用户分时段奖励场景',
  'activity.register.defaultReward': '默认奖励',
  'activity.register.defaultRewardDesc': '未命中任何规则时适用',
  'activity.register.spinCount': '转盘次数',
  'activity.register.spinTicket': '指定转盘',
  'activity.register.spinTicketPlaceholder': '默认转盘',
  'activity.register.agentLineRules': '按代理线派发不同奖励',
  'activity.register.rule': '规则',
  'activity.register.agentLines': '适用代理线',
  'activity.register.addAgentLine': '+ 添加代理线',
  'activity.register.addAgentLineRule': '+ 添加代理线规则',
  'activity.register.agentIdDuplicate': '同一代理不能出现在多条规则中',
  'activity.register.agentLinesRequired': '请至少选择一个代理线',
  'activity.register.onlyTempUser': '仅派发临时表用户',
  'activity.register.onlyTempUserDesc': '开启后仅对临时表注册用户派发，其它来源的用户跳过派发',

  // 每日首充模板翻译
  'activity.dailyFirstRecharge.title': '每日首充设置',
  'activity.dailyFirstRecharge.basicSettings': '基础设置',
  'activity.dailyFirstRecharge.cashRewardSettings': '现金奖励设置',
  'activity.dailyFirstRecharge.pointRewardSettings': '积分奖励设置',
  'activity.dailyFirstRecharge.rewardLimitSettings': '奖励限制设置',
  'activity.dailyFirstRecharge.dailyMinRechargeAmount': '每日最低存款（含）',
  'activity.dailyFirstRecharge.dailyMaxRechargeAmount': '每日最高存款（含）',
  'activity.dailyFirstRecharge.cashAwardMethod': '现金优惠方式',
  'activity.dailyFirstRecharge.cashAmount': '现金金额',
  'activity.dailyFirstRecharge.desireMultiple': '流水倍数',
  'activity.dailyFirstRecharge.pointAwardMethod': '积分优惠方式',
  'activity.dailyFirstRecharge.pointAmount': '积分金额',
  'activity.dailyFirstRecharge.awardMax': '赠送最高限制',
  'activity.dailyFirstRecharge.enterDailyMinRechargeAmount': '请输入每日最低存款金额',
  'activity.dailyFirstRecharge.enterDailyMaxRechargeAmount': '请输入每日最高存款金额',
  'activity.dailyFirstRecharge.selectCashAwardMethod': '请选择现金优惠方式',
  'activity.dailyFirstRecharge.selectPointAwardMethod': '请选择积分优惠方式',
  'activity.dailyFirstRecharge.enterCashAmount': '请输入现金金额',
  'activity.dailyFirstRecharge.enterDesireMultiple': '请输入流水倍数',
  'activity.dailyFirstRecharge.enterPointAmount': '请输入积分金额',
  'activity.dailyFirstRecharge.enterAwardMax': '请输入赠送最高限制',
  'activity.dailyFirstRecharge.fixedAmount': '固定金额',
  'activity.dailyFirstRecharge.percentage': '按比例',
  'activity.dailyFirstRecharge.amountMustBeNonNegative': '金额不能为负数',
  'activity.dailyFirstRecharge.amountMustBePositive': '金额必须大于0',
  'activity.dailyFirstRecharge.multipleMustBePositive': '流水倍数必须大于0',
  'activity.dailyFirstRecharge.maxMustBeGreaterThanMin': '最高存款必须大于最低存款',
  'activity.dailyFirstRecharge.dailyMinRechargeAmountTooltip': '用户当日累计存款必须达到此金额才能参与活动',
  'activity.dailyFirstRecharge.dailyMaxRechargeAmountTooltip': '用户当日累计存款的上限，超过此金额的部分不参与活动计算',
  'activity.dailyFirstRecharge.cashAwardMethodTooltip': '选择现金奖励的计算方式：固定金额或按存款比例',
  'activity.dailyFirstRecharge.cashAmountTooltip': '固定方式：直接奖励金额；比例方式：奖励百分比（如10表示10%）',
  'activity.dailyFirstRecharge.desireMultipleTooltip': '获得现金奖励需要完成的流水要求倍数',
  'activity.dailyFirstRecharge.pointAwardMethodTooltip': '选择积分奖励的计算方式：固定数量或按存款比例',
  'activity.dailyFirstRecharge.pointAmountTooltip': '固定方式：直接奖励积分数量；比例方式：奖励百分比（如5表示5%）',
  'activity.dailyFirstRecharge.awardMaxTooltip': '单次活动中用户能获得的最大奖励金额上限',
  'activity.dailyFirstRecharge.note': '注意事项',
  'activity.dailyFirstRecharge.noteAmountRange': '每日最低存款必须小于每日最高存款',
  'activity.dailyFirstRecharge.noteAwardMethod': '奖励方式：固定=直接金额/数量，比例=按存款百分比计算',
  'activity.dailyFirstRecharge.noteFlowMultiple': '流水倍数用于现金奖励的提取要求',
  'activity.dailyFirstRecharge.noteAwardMax': '最高奖励限制是现金和积分奖励的总和上限',
  'activity.dailyFirstRecharge.dailyMinAmount': '每日最小金额',
  'activity.dailyFirstRecharge.dailyMaxAmount': '每日最大金额',
  'activity.dailyFirstRecharge.dailyMinAmountTooltip': '会员单日充值金额的最小限制',
  'activity.dailyFirstRecharge.rechargePageDescription': '充值页面描述',
  'activity.dailyFirstRecharge.descriptionZhCN': '简体中文',
  'activity.dailyFirstRecharge.descriptionEnUS': '英文',
  'activity.dailyFirstRecharge.descriptionViVN': '越南语',
  'activity.dailyFirstRecharge.enterDescription': '请输入描述',
  'activity.dailyFirstRecharge.dailyMaxAmountTooltip': '会员单日充值金额的最大限制',
  'activity.dailyFirstRecharge.dailyMaxAmountError': '每日最大金额必须大于最小金额',
  'activity.dailyFirstRecharge.enterCashPercentage': '请输入现金奖励百分比',
  'activity.dailyFirstRecharge.enterPointPercentage': '请输入积分奖励百分比',
  'activity.dailyFirstRecharge.percentageMaxError': '百分比不能超过100%',

  // 充值优惠设置
  'activity.recharge.title': '充值优惠设置',
  'activity.recharge.rechargeCount': '本活动存款次序',
  'activity.recharge.minRechargeAmount': '最低存款(含)',
  'activity.recharge.maxRechargeAmount': '最高存款(含)',
  'activity.recharge.cashRewardSettings': "现金",
  'activity.recharge.pointRewardSettings': '积分',
  'activity.recharge.awardMax': '赠送最高限制',
  'activity.recharge.addCondition': '添加充值条件',
  'activity.recharge.confirmDelete': '确认删除此条件？',
  'activity.recharge.enterRechargeCount': '请输入充值次数',
  'activity.recharge.enterMinRechargeAmount': '请输入单次最低充值金额',
  'activity.recharge.enterMaxRechargeAmount': '请输入单次最高充值金额',
  'activity.recharge.selectCashAwardMethod': '请选择现金优惠方式',
  'activity.recharge.selectPointAwardMethod': '请选择积分优惠方式',
  'activity.recharge.enterCashAmount': '请输入现金金额',
  'activity.recharge.enterDesireMultiple': '请输入流水倍数',
  'activity.recharge.enterPointAmount': '请输入积分金额',
  'activity.recharge.enterAwardMax': '请输入赠送最高限制',
  'activity.recharge.enterCashPercentage': '请输入现金奖励百分比',
  'activity.recharge.enterPointPercentage': '请输入积分奖励百分比',
  'activity.recharge.fixedAmount': '固定金额',
  'activity.recharge.percentage': '按比例',
  'activity.recharge.amountMustBePositive': '金额必须大于0',
  'activity.recharge.rechargeCountMustBePositiveInteger': '充值次数必须为正整数',
  'activity.recharge.maxAmountError': '最高充值金额必须大于最低充值金额',
  'activity.recharge.percentageMaxError': '百分比不能超过100%',
  'activity.recharge.truncateNotice': '优惠比例支持小数点后两位；按比例计算的现金奖励金额保留2位小数，超出部分直接舍弃（不四舍五入），不足0.01的奖励将舍弃不派发；积分奖励不受影响。',
  'activity.recharge.cashAwardMethodTooltip': '选择现金奖励的计算方式：固定金额或按充值比例',
  'activity.recharge.pointAwardMethodTooltip': '选择积分奖励的计算方式：固定数量或按充值比例',
  'activity.recharge.awardMaxTooltip': '单次活动中用户能获得的最大奖励金额上限',
  'activity.recharge.rechargeCountMustBeUnique': '充值次数不能重复',
  'activity.recharge.rechargeCountMustBeConsecutive': '充值次数必须连续',
  'activity.recharge.cannotBothBeZero': '现金奖励和积分奖励不能同时为0',
  'activity.recharge.stage': '阶段',
  'activity.recharge.copyStage': '复制阶段',
  'activity.recharge.deleteStage': '删除阶段',
  'activity.recharge.enterRechargeCountPlaceholder': '请输入 N, 如第1次、第2次',
  'activity.recharge.awardDistribution': '发放奖励',
  'activity.recharge.cashAward': '现金奖励',
  'activity.recharge.selectAwardMethod': '请选择赠送方式',
  'activity.recharge.enterPercentage': '请输入比例',
  'activity.recharge.enterFixedAmount': '请输入固定金额',
  'activity.recharge.maxCashAmount': '请输入最高赠送金额 (-1代表无限制)',
  'activity.recharge.maxAmountValidation': '请输入-1或大于等于0的数值',
  'activity.recharge.desireMultiple': '请输入流水倍数 (空或0则无流水限制)',
  'activity.recharge.pointAward': '积分奖励',
  'activity.recharge.enterFixedPoints': '请输入固定积分',
  'activity.recharge.maxPointAmount': '请输入最高赠送积分 (-1代表无限制)',
  'activity.recharge.lotteryTicket': '抽奖参与券',
  'activity.recharge.selectLotteryActivity': '请选择抽奖活动',
  'activity.recharge.ticketCount': '请输入数量 (默认1)',
  'activity.recharge.enterTicketCount': '请输入数量',
  'activity.recharge.ticketCountNonNegative': '数量不能为负数',
  'activity.recharge.addStage': '+ 新增阶段',
  // CB7REQ-331 阶段内金额阶梯
  'activity.recharge.tier': '档位',
  'activity.recharge.addTier': '＋ 新增档位',
  'activity.recharge.deleteTier': '删除档位',
  'activity.recharge.tierLast': '最后一档 · 无上限',
  'activity.recharge.tierRangeNoUpper': '≥ {min}（含），无上限',
  'activity.recharge.tierRange': '{min}（含）– {max}（不含）',
  'activity.recharge.tierRangePending': '区间待修正',
  'activity.recharge.tierMinMustIncrease': '档位下限必须严格大于上一档下限',
  'activity.recharge.tierListTitle': '金额阶梯（按单笔存款金额落档，互斥派发）',
  'activity.recharge.tierListHint': '低于第一档下限的存款不派奖 · 每档只填「最低存款(含)」，上限自动 = 下一档下限（不含），最后一档无上限 · 档位下限需严格递增，保存时后端二次校验',
  'activity.recharge.tierUpperAuto': '上限自动 = 下一档下限（不含）',
  'activity.recharge.capOnlyLastTier': '封顶字段仅在最后一档出现（本档无区间上限，按比例奖励需要封顶）；-1 代表无限制。',

  // Login Recharge Template
  'activity.loginRecharge.promotionSettings': '登入充值抽奖设置',
  'activity.loginRecharge.awardName': '奖品名称',
  'activity.loginRecharge.pointAmount': '奖励积分',
  'activity.loginRecharge.winners': '可获奖人数',
  'activity.loginRecharge.type': '获奖类型',
  'activity.loginRecharge.deposit': '存款',
  'activity.loginRecharge.login': '登入',
  'activity.loginRecharge.addCondition': '新增条件',
  'activity.loginRecharge.atLeastOneCondition': '至少需要一个条件',
  'activity.loginRecharge.awardNameRequired': '奖品名称不能为空',
  'activity.loginRecharge.pointAmountRequired': '奖励积分不能为空',
  'activity.loginRecharge.winnersRequired': '可获奖人数不能为空',
  'activity.loginRecharge.enterAwardName': '请输入奖品名称',
  'activity.loginRecharge.awardNameMaxLength': '奖品名称最多100个字符',
  'activity.loginRecharge.enterPointAmount': '请输入奖励积分',
  'activity.loginRecharge.pointAmountMustBePositive': '奖励积分必须大于0',
  'activity.loginRecharge.enterWinners': '请输入可获奖人数',
  'activity.loginRecharge.winnersMustBePositive': '可获奖人数必须大于0',
  'activity.loginRecharge.selectType': '请选择获奖类型',
  'activity.loginRecharge.memberAccount': '会员账号',
  'activity.loginRecharge.memberAccountPlaceholder': '请输入会员账号',

  // Activity Operate Management
  'activity.operate.loginRecharge': '登入充值抽奖',
  'activity.loginRecharge.triggerAmount': '触发金额',
  'activity.loginRecharge.drawDate': '开奖日期',
  'activity.loginRecharge.activityName': '活动名称',
  'activity.loginRecharge.status': '状态',
  'activity.loginRecharge.numberPlate': '号码牌',
  'activity.loginRecharge.awardStatus': '奖励状态',
  'activity.loginRecharge.createTime': '创建时间',
  'activity.loginRecharge.pendingDraw': '待开奖',
  'activity.loginRecharge.drawn': '已开奖',
  'activity.loginRecharge.notWin': '未中奖',
  'activity.loginRecharge.pendingAward': '待发放',
  'activity.loginRecharge.received': '已领取',
  'activity.loginRecharge.awardStatusPlaceholder': '请选择奖励状态',
  'activity.loginRecharge.awardAmount': '获奖金额',
  'activity.loginRecharge.operator': '操作人',
  'activity.loginRecharge.operateTime': '操作时间',
  'activity.loginRecharge.updateShareLink': '更新分享链接',
  'activity.loginRecharge.dataPkCode': '系统流水号',
  'activity.loginRecharge.shareLink': '分享链接',
  'activity.loginRecharge.dataPkCodeRequired': '系统流水号不能为空',
  'activity.loginRecharge.shareLinkRequired': '分享链接不能为空',
  'activity.loginRecharge.shareLinkPlaceholder': '请输入分享链接',
  'activity.loginRecharge.socialMediaLink': '社媒链接',
  'activity.loginRecharge.invalidLink': '无效的链接格式',
  'activity.loginRecharge.sendAward': '发放奖励',
  'activity.loginRecharge.awardSentSuccess': '奖励发放成功',
  'activity.loginRecharge.awardSentFail': '奖励发放失败',
  'activity.loginRecharge.awardSending': '奖励发放中，请稍候...',
  'activity.loginRecharge.batchSend': '批量发放',
  'activity.loginRecharge.batchSendConfirm': '确认批量发放',
  'activity.loginRecharge.batchSendConfirmMessage': '确定要批量发放选中的 {{count}} 条记录吗？\n\n注意：批量发放将在后台异步处理，请稍后刷新页面查看结果。',
  'activity.loginRecharge.batchSendConfirmContent': '确定要批量发放选中的 {{count}} 条记录吗？',
  'activity.loginRecharge.batchSendAsyncNotice': '注意：批量发放将在后台异步处理，请稍后刷新列表查看结果。请勿重复发放。',
  'activity.loginRecharge.confirmSend': '确认发放',
  'activity.loginRecharge.batchSendTaskSubmitted': '批量发放任务已提交，正在后台处理中',
  'activity.loginRecharge.batchSendSuccess': '批量发放任务提交成功',
  'activity.loginRecharge.batchSendFail': '批量发放任务提交失败',
  'activity.loginRecharge.batchSending': '正在提交批量发放任务...',
  'activity.loginRecharge.selectRecordsToSend': '请选择要发放的记录',
  'activity.loginRecharge.selectRecordsFirst': '请先选择要发放的记录',
  'activity.loginRecharge.eligibleRecords': '可发放记录',
  'activity.loginRecharge.selectAllEligible': '全选可发放',

  // Redemption Record Management
  'activity.redemptionRecord.useTime': '兑换码使用时间',
  'activity.redemptionRecord.actNameOrId': '活动名称/ID',
  'activity.redemptionRecord.actNameOrIdPlaceholder': '请输入活动名称或ID',
  'activity.redemptionRecord.redemptionCode': '兑换码',
  'activity.redemptionRecord.redemptionCodePlaceholder': '请输入兑换码',
  'activity.redemptionRecord.memberAccount': '会员账号',
  'activity.redemptionRecord.memberAccountPlaceholder': '请输入会员账号',
  'activity.redemptionRecord.promotionName': '优惠名称',
  'activity.redemptionRecord.usageMode': '兑换方式',
  'activity.redemptionRecord.awardContent': '奖励内容',
  'activity.redemptionRecord.distributionMethod': '发放模式',
  'activity.redemptionRecord.redemptionTime': '使用时间',
  'activity.redemptionRecord.singleUse': '单次使用',
  'activity.redemptionRecord.reusable': '重复使用',
  'activity.redemptionRecord.manualDistribution': '手工发放',

  // Redemption Code Management
  'activity.redemptionCode.list': '兑换码列表',
  'activity.redemptionCode.usageRecord': '兑换码使用记录',
  'activity.redemptionCode.promotionName': '优惠名称',
  'activity.redemptionCode.promotionId': '优惠id',
  'activity.redemptionCode.awardAmount': '兑换奖励',
  'activity.redemptionCode.status': '状态',
  'activity.redemptionCode.enabled': '开启',
  'activity.redemptionCode.disabled': '关闭',
  'activity.redemptionCode.codeQuantity': '兑换码数量',
  'activity.redemptionCode.unlimited': '不限',
  'activity.redemptionCode.usageMode': '使用模式',
  'activity.redemptionCode.reusable': '重复使用',
  'activity.redemptionCode.singleUse': '单次使用',
  'activity.redemptionCode.unknown': '未知',
  'activity.redemptionCode.distributionMethod': '派发方式',
  'activity.redemptionCode.manualDistribution': '手动派发',
  'activity.redemptionCode.autoDistribution': '自动派发',
  'activity.redemptionCode.usedCount': '已使用数',
  'activity.redemptionCode.operator': '操作人',
  'activity.redemptionCode.operation': '操作',
  'activity.redemptionCode.quantity': '数量',
  // Redemption Code Forms and Modals
  'activity.redemptionCode.createSuccess': '创建成功',
  'activity.redemptionCode.createFailed': '创建失败',
  'activity.redemptionCode.disableSuccess': '禁用成功',
  'activity.redemptionCode.enableSuccess': '启用成功',
  'activity.redemptionCode.confirmDisable': '确认禁用',
  'activity.redemptionCode.confirmEnable': '确认启用',
  'activity.redemptionCode.couponSettings': '兑换码设置',
  'activity.redemptionCode.promotionNameRequired': '请输入优惠名称',
  'activity.redemptionCode.promotionNamePlaceholder': '请输入优惠名称',
  'activity.redemptionCode.distributionMethodRequired': '请选择派发方式',
  'activity.redemptionCode.distributionMethodPlaceholder': '请选择派发方式',
  'activity.redemptionCode.usageModeRequired': '请选择使用模式',
  'activity.redemptionCode.usageModePlaceholder': '请选择使用模式',
  'activity.redemptionCode.availableTimeRequired': '请选择可使用时间',
  'activity.redemptionCode.availableTimePlaceholder': ['开始时间', '结束时间'],
  'activity.redemptionCode.availableTime': '可使用时间',
  'activity.redemptionCode.uniqueCodeRequired': '请输入唯一兑换码',
  'activity.redemptionCode.uniqueCodeEmpty': '兑换码不能为空',
  'activity.redemptionCode.uniqueCodePlaceholder': '如: PROMO2025',
  'activity.redemptionCode.perUserLimitRequired': '请输入每人限使用次数',
  'activity.redemptionCode.perUserLimitPattern': '请输入正整数',
  'activity.redemptionCode.perUserLimitPlaceholder': '1 (固定)',
  'activity.redemptionCode.totalUsageRequired': '请输入总可使用次数',
  'activity.redemptionCode.totalUsagePattern': '请输入-1（不限次数）或正整数',
  'activity.redemptionCode.totalUsagePlaceholder': '-1（不限次数）或正整数',
  'activity.redemptionCode.prefixRequired': '请输入单次使用前缀',
  'activity.redemptionCode.prefixMaxLength': '前缀最多4个字符',
  'activity.redemptionCode.prefixPattern': '只能包含字母和数字',
  'activity.redemptionCode.prefixPlaceholder': '如: PROM',
  'activity.redemptionCode.awardTypeRequired': '请选择奖励类型',
  'activity.redemptionCode.awardTypePlaceholder': '请选择奖励类型',
  'activity.redemptionCode.awardType': '奖励类型',
  'activity.redemptionCode.pointAmountRequired': '请输入积分数量',
  'activity.redemptionCode.pointAmountPattern': '请输入正整数',
  'activity.redemptionCode.pointAmountPlaceholder': '积分数量 (正整数)',
  'activity.redemptionCode.cashAmountRequired': '请输入现金金额',
  'activity.redemptionCode.cashAmountPattern': '请输入有效金额',
  'activity.redemptionCode.cashAmountPlaceholder': '现金金额',
  'activity.redemptionCode.currencyRequired': '请选择币种',
  'activity.redemptionCode.currencyPlaceholder': '请选择币种',
  'activity.redemptionCode.turnoverMultipleRequired': '请输入流水倍数',
  'activity.redemptionCode.turnoverMultiplePlaceholder': '流水倍数',
  // Redemption Code Operations and Modals
  'activity.redemptionCode.addCodes': '新增券码',
  'activity.redemptionCode.addUsageCount': '增加使用次数',
  'activity.redemptionCode.showUniqueCode': '兑换码信息',
  'activity.redemptionCode.exportCodes': '导出券码',
  'activity.redemptionCode.copySuccess': '兑换码已复制到剪贴板',
  'activity.redemptionCode.copyFailed': '复制失败',
  'activity.redemptionCode.copyCode': '复制兑换码',
  'activity.redemptionCode.copyInstructions': '点击"复制兑换码"按钮可以将兑换码复制到剪贴板',
  'activity.redemptionCode.batchNumber': '批次号',
  'activity.redemptionCode.batchQuantity': '数量',
  'activity.redemptionCode.generationStatus': '生成状态',
  'activity.redemptionCode.generating': '生成中',
  'activity.redemptionCode.completed': '生成完成',
  'activity.redemptionCode.failed': '生成失败',
  'activity.redemptionCode.batchOperator': '操作人',
  'activity.redemptionCode.batchCreateTime': '创建时间',
  'activity.redemptionCode.batchOperation': '操作',
  'activity.redemptionCode.getBatchListFailed': '获取批次列表失败',
  'activity.redemptionCode.exportFailed': '导出失败',
  'activity.redemptionCode.availableDate': '可兑换日期',
  'activity.redemptionCode.activityName': '活动名称',
  'activity.redemptionCode.activityNamePlaceholder': '请输入活动名称',
  'activity.redemptionCode.creator': '创建人',
  'activity.redemptionCode.creatorPlaceholder': '请输入创建人',
  'activity.redemptionCode.statusPlaceholder': '请选择状态',
  // Additional missing translations
  'activity.redemptionCode.points': '积分',
  'activity.redemptionCode.cash': '现金',
  'activity.redemptionCode.unlimitedTimes': '不限次数',
  'activity.redemptionCode.timesUnit': '次',
  'activity.redemptionCode.quantityUnit': '数量',
  'activity.redemptionCode.dataLoadFailed': '数据加载失败',
  'activity.redemptionCode.queryParams': '查询参数',
  'activity.redemptionCode.createRedemptionCodeFailed': '创建兑换码失败',
  'activity.redemptionCode.startTime': '开始时间',
  'activity.redemptionCode.endTime': '结束时间',
  'activity.redemptionCode.totalUsageLabel': '总可使用次数 (输入-1代表不限次数)',
  'activity.redemptionCode.prefixLabel': '前缀（规定最多四码，系统产生5码）',
  'activity.redemptionCode.addCodesSuccess': '券码生成成功',
  'activity.redemptionCode.addCodesFailed': '券码生成失败',
  'activity.redemptionCode.addUsageCountSuccess': '使用次数增加成功',
  'activity.redemptionCode.addUsageCountFailed': '使用次数增加失败',
  'activity.redemptionCode.addCodesTitle': '新增券码',
  'activity.redemptionCode.addUsageCountTitle': '增加使用次数',
  'activity.redemptionCode.redemptionCodeName': '兑换码名称',
  'activity.redemptionCode.currentTotalUsage': '当前总使用次数',
  'activity.redemptionCode.unlimitedUsage': '不限次数',
  'activity.redemptionCode.addUsageCountRequired': '请输入增加的使用次数',
  'activity.redemptionCode.addUsageCountRange': '使用次数必须在1-100000之间',
  'activity.redemptionCode.addUsageCountPlaceholder': '请输入增加的使用次数',
  'activity.redemptionCode.singleUsePrefix': '单次使用前缀',
  'activity.redemptionCode.addCodesQuantityRequired': '请输入新增券码数量',
  'activity.redemptionCode.addCodesQuantityRange': '券码数量必须在1-100000之间',
  'activity.redemptionCode.addCodesQuantityPlaceholder': '请输入新增券码数量',
  'activity.redemptionCode.showUniqueCodeTitle': '兑换码信息',
  'activity.redemptionCode.exportCodesTitle': '导出券码',
  // 公共翻译
  'common.operation': '操作',
  'common.delete': '删除',
  'common.save': '保存',
  'common.action': '操作',
  'common.saveSuccess': '保存成功',
  'common.saveFailed': '保存失败',
  'common.confirm': '确认',
  'common.cancel': '取消',
  'common.settings': '设置',
  'common.view': '查看',
  'common.all': '全部',
  // Additional missing translations for forms
  'activity.redemptionCode.codeUnit': '個',
  'activity.redemptionCode.perUserUnit': '人次',
  'activity.redemptionCode.export': '导出',
  // Button translations
  'common.search': '查询',
  'common.reset': '重置',
  'common.add': '新增',
  'common.disable': '禁用',
  'common.enable': '启用',
  // Confirmation dialog messages
  'activity.redemptionCode.confirmDisableMessage': '确定要禁用兑换码 "{{actName}}" 吗？',
  'activity.redemptionCode.confirmEnableMessage': '确定要启用兑换码 "{{actName}}" 吗？',
  // Show unique code modal
  'activity.redemptionCode.activityNameLabel': '活动名称：',
  'activity.redemptionCode.redemptionCodeLabel': '兑换码：',
  'activity.redemptionCode.close': '关闭',
  // Add codes modal
  'activity.redemptionCode.uniqueCode': '唯一兑换码',
  'activity.redemptionCode.addUsageCountLabel': '增加使用次数',
  'activity.redemptionCode.addCodesQuantityLabel': '新增券码数量',
  'activity.redemptionCode.cancel': '取消',
  'activity.redemptionCode.confirm': '确定',
  'activity.redemptionCode.reusableModeDescription': '• 重复使用模式：增加兑换码的总使用次数',
  'activity.redemptionCode.systemUpdateDescription': '• 系统将更新兑换码的总使用次数限制',
  'activity.redemptionCode.maxUsageDescription': '• 最大支持增加到10万次使用',
  // Add redemption code modal
  'activity.redemptionCode.perUserLimit': '每人限使用',
  'activity.redemptionCode.totalUsageLimit': '总可使用次数 (输入-1代表不限次数)',
  'activity.redemptionCode.singleUsePrefixLabel': '前缀（规定最多四码，系统产生5码）',
  'activity.redemptionCode.singleUsePrefixRequired': '请输入单次使用前缀',
  'activity.redemptionCode.singleUsePrefixMaxLength': '前缀最多4个字符',
  'activity.redemptionCode.singleUsePrefixPattern': '只能包含字母和数字',
  'activity.redemptionCode.singleUsePrefixPlaceholder': '如: PROM',
  'activity.redemptionCode.pointAmount': '积分数量',
  'activity.redemptionCode.cashAmount': '现金金额',
  'activity.redemptionCode.currency': '币种',
  'activity.redemptionCode.turnoverMultiple': '流水倍数',
  'activity.redemptionCode.singleUseDescription': '为保证券码足够的短，系统仅生成5码，单次使用的任务',
  'activity.redemptionCode.maxCodesDescription': '最大建10万个券码',
  // Reward mode (奖励模式)
  'activity.redemptionCode.rewardMode': '奖励模式',
  'activity.redemptionCode.rewardModeRequired': '请选择奖励模式',
  'activity.redemptionCode.rewardModePlaceholder': '请选择奖励模式',
  'activity.redemptionCode.fixedMode': '固定',
  'activity.redemptionCode.rangeMode': '区间',
  'activity.redemptionCode.randomReward': '随机奖励',
  'activity.redemptionCode.randomPoints': '随机积分',
  'activity.redemptionCode.randomCash': '随机现金',
  // Range settings (区间设置)
  'activity.redemptionCode.atLeastOneRange': '请至少添加一个区间',
  'activity.redemptionCode.minAmount': '最小金额',
  'activity.redemptionCode.minAmountRequired': '请输入最小金额',
  'activity.redemptionCode.minAmountMustBeGreaterThanZero': '最小金额必须大于0',
  'activity.redemptionCode.maxAmount': '最大金额',
  'activity.redemptionCode.maxAmountRequired': '请输入最大金额',
  'activity.redemptionCode.probability': '概率 (%)',
  'activity.redemptionCode.probabilityRequired': '请输入概率',
  'activity.redemptionCode.probabilityMax100': '概率不能超过100%',
  'activity.redemptionCode.positiveIntegerRequired': '请输入正整数',
  'activity.redemptionCode.validNumber': '请输入有效数字',
  'activity.redemptionCode.validNumberMax2Decimal': '请输入有效数字（最多2位小数）',
  'activity.redemptionCode.addRange': '添加',
  'activity.redemptionCode.probabilitySumNote': '所有区间的概率总和必须为 100%',
  'activity.redemptionCode.probabilityMustBe100': '区间设置的概率总和必须为 100%',
  // Export codes modal
  'activity.redemptionCode.totalRecords': '共 {{total}} 条记录',

  // 大转盘模板翻译
  'activity.luckySpin.pcIcon': '大转盘PC标题图片',
  'activity.luckySpin.selectPcIcon': '请选择大转盘PC标题图片',
  'activity.luckySpin.h5Icon': '大转盘H5标题图片',
  'activity.luckySpin.selectH5Icon': '请选择大转盘H5标题图片',
  'activity.luckySpin.appIcon': '大转盘APP标题图片',
  'activity.luckySpin.selectAppIcon': '请选择大转盘APP标题图片',
  'activity.confirmDelete': '确认要删除活动?',

  // 自定义模板翻译
  'activity.custom.taskType': '任务类型',
  'activity.custom.selectTaskType': '请选择任务类型',
  'activity.custom.once': '一次性',
  'activity.custom.repeat': '重复性',
  'activity.custom.taskCycle': '任务周期',
  'activity.custom.selectTaskCycle': '请选择任务周期',
  'activity.custom.daily': '每日',
  'activity.custom.weekly': '每周',
  'activity.custom.permanent': '永久',
  'activity.custom.cashRewardDisplay': '现金奖励显示',
  'activity.custom.enterCashRewardDisplay': '请输入现金奖励显示',
  'activity.custom.pointRewardDisplay': '积分奖励显示',
  'activity.custom.enterPointRewardDisplay': '请输入积分奖励显示',
  'activity.custom.ticketRewardDisplay': '抽奖券奖励显示',
  'activity.custom.enterTicketRewardDisplay': '请输入抽奖券奖励显示',
  'activity.custom.unlockButtonName': '解锁状态按钮名称',
  'activity.custom.enterUnlockButtonName': '请输入解锁状态按钮名称',
  'activity.custom.buttonJumpLink': '按钮跳转链接',
  'activity.custom.enterButtonJumpLink': '请输入按钮跳转链接',
  'activity.custom.rewardDisplay': '奖励显示设置',
  'activity.custom.vipLevelMode': 'VIP等级选择模式',
  'activity.custom.singleSelect': '单选',
  'activity.custom.multipleSelect': '多选',
  'activity.custom.vipLevel': 'VIP等级',
  'activity.custom.vipLevels': 'VIP等级',
  'activity.custom.selectVipLevel': '请选择VIP等级',
  'activity.custom.selectVipLevels': '请选择VIP等级',

  // 笔笔存优惠模板翻译
  'activity.everyRecharge.configTitle': '笔笔存优惠配置',
  'activity.everyRecharge.minRechargeAmount': '单笔充值 ≥',
  'activity.everyRecharge.maxRechargeAmount': '单笔充值 ≤',
  'activity.everyRecharge.awardType': '优惠赠送',
  'activity.everyRecharge.amount': '数额',
  'activity.everyRecharge.turnover': '流水',
  'activity.everyRecharge.settings': '设置',
  'activity.everyRecharge.add': '添加',
  'activity.everyRecharge.addNew': '新增',
  'activity.everyRecharge.delete': '删除',
  'activity.everyRecharge.cash': '现金',
  'activity.everyRecharge.point': '积分',
  'activity.everyRecharge.ticket': '参与券',
  'activity.everyRecharge.pleaseSelect': '请选择',
  'activity.everyRecharge.selectAwardType': '请选择优惠类型',
  'activity.everyRecharge.selectTicket': '请选择参与券',
  'activity.everyRecharge.enterMinRechargeAmount': '请输入单笔充值下限',
  'activity.everyRecharge.enterMaxRechargeAmount': '请输入单笔充值上限',
  'activity.everyRecharge.enterAmount': '请输入',
  'activity.everyRecharge.enterTurnover': '请输入',
  'activity.everyRecharge.amountMustBePositive': '金额必须大于0',
  'activity.everyRecharge.turnoverMustBePositive': '流水倍数必须大于等于0',
  'activity.everyRecharge.minMustLessThanMax': '下限必须小于上限',
  'activity.everyRecharge.maxMustGreaterThanMin': '上限必须大于下限',
  'activity.everyRecharge.rangeOverlap': '充值金额区间不能与其他档位重叠',
  'activity.everyRecharge.tierDescription': '充值页面描述',
  'activity.everyRecharge.awardSettings': '奖励设置',
  'activity.everyRecharge.globalDescription': '充值优惠描述',

  // 首存优惠模板
  'activity.firstDeposit.configTitle': '存款优惠配置',
  'activity.firstDeposit.minRechargeAmount': '首存充值 ≥',
  'activity.firstDeposit.maxRechargeAmount': '首存充值 ≤',
  'activity.firstDeposit.awardType': '优惠赠送',
  'activity.firstDeposit.amount': '数额',
  'activity.firstDeposit.turnover': '流水',
  'activity.firstDeposit.addNew': '+ 新增',
  'activity.firstDeposit.delete': '删除',
  'activity.firstDeposit.cash': '现金',
  'activity.firstDeposit.point': '积分',
  'activity.firstDeposit.ticket': '参与券',
  'activity.firstDeposit.pleaseSelect': '请选择',
  'activity.firstDeposit.selectAwardType': '请选择优惠类型',
  'activity.firstDeposit.selectTicket': '请选择参与券',
  'activity.firstDeposit.enterMinRechargeAmount': '请输入首存充值下限',
  'activity.firstDeposit.enterMaxRechargeAmount': '请输入首存充值上限',
  'activity.firstDeposit.enterAmount': '请输入',
  'activity.firstDeposit.enterTurnover': '请输入',
  'activity.firstDeposit.amountMustBePositive': '金额必须大于0',
  'activity.firstDeposit.amountMustBeInteger': '数额必须为整数',
  'activity.firstDeposit.turnoverMustBePositive': '流水倍数必须大于等于0',
  'activity.firstDeposit.minMustLessThanMax': '下限必须小于上限',
  'activity.firstDeposit.maxMustGreaterThanMin': '上限必须大于下限',
  'activity.firstDeposit.awardSettings': '奖项设置',
  'activity.firstDeposit.rechargePageDescription': '充值页面描述',
  'activity.firstDeposit.enterDescription': '请输入描述',
  'activity.firstDeposit.distributeMode': '派发方式',
  'activity.firstDeposit.distributeModeDirect': '直接派发到用户账户',
  'activity.firstDeposit.distributeModeDirectDesc': '首次充值后，现金入主账户、积分入积分账户、转盘次数自动发放',
  'activity.firstDeposit.distributeModeCoupon': '派发至优惠中心待领取',
  'activity.firstDeposit.distributeModeCouponDesc': '首次充值后，奖励出现在优惠中心，用户手动领取后到账',

  // 邀请好友模板
  'activity.invite.inviteRulesAndRewards': '邀请规则与奖励设置',
  'activity.invite.inviteRulesLogic': '逻辑：每产生 1 个"有效好友"，邀请人可在客户端 To Claim 手动领取邀请奖励；若开启"同时奖励被邀请人"，则被邀请人在变为有效用户时自动发放奖励（默认到账主账户）。',
  'activity.invite.inviteRulesDetail': '现金：数量 + 流水倍数（需完成流水 = 领取金额 × 倍数）；积分：仅数量；大转盘：类型 + 数量（可多条）。',
  'activity.invite.taskNameMultiLang': '邀请奖励任务名（多语言）',
  'activity.invite.taskNameDescription': '按基础信息选择的多语言展示：',
  'activity.invite.enterTaskName': '请输入邀请奖励任务名',
  'activity.invite.inviterReward': '邀请人奖励（To Claim 手动领取）',
  'activity.invite.inviterRewardDescription': '现金：数量 + 流水倍数（需完成流水 = 领取金额 × 倍数）；积分：仅数量；大转盘：类型 + 数量（可多条）。',
  'activity.invite.inviteeReward': '同时奖励被邀请人（自动发放）',
  'activity.invite.inviteeRewardDescription': '开启后：每个有效好友触发时，邀请人产生 To Claim 任务；被邀请人自动发放本列配置的奖励（默认到账主账户）。',
  'activity.invite.amount': '数额',
  'activity.invite.turnoverMultiple': '流水倍数',
  'activity.invite.pointsNoTurnover': '积分无流水倍数',
  'activity.invite.selectTicket': '请选择参与券',
  'activity.invite.addTicketReward': '新增大转盘奖励',
  'activity.invite.achievementReward': '成就奖励（邀请人）',
  'activity.invite.achievementRulesLine1': '规则：成就奖励不再按币种拆分；币种以基础信息为准（PHP）。',
  'activity.invite.achievementRulesLine2': '成就奖励"奖励名称"支持多语言：随基础信息多语言进行增减。',
  'activity.invite.achievementLevel': '门槛',
  'activity.invite.rewardIcon': '奖励图标',
  'activity.invite.threshold': '门槛（有效好友数 ≥）',
  'activity.invite.enterThreshold': '请输入门槛',
  'activity.invite.rewardNameMultiLang': '奖励名称（多语言）',
  'activity.invite.enterRewardName': '请输入成就奖励名称',
  'activity.invite.enableCash': '启用',
  'activity.invite.enablePoint': '启用',
  'activity.invite.enableTicket': '启用',
  'activity.invite.addAchievementLevel': '新增成就门槛',
  'activity.invite.cashTurnoverNote': '现金需完成流水 = 现金金额 × 流水倍数；积分/大转盘仅数量。',

  'activity.invite.rewardModeFixed': '按有效会员固定奖励',
  'activity.invite.rewardModeFirstDeposit': '按首充金额区间奖励',
  'activity.invite.rewardModeHint': '同时只生效一种。切换仅对切换后新邀请的会员生效；已邀请会员按其被邀请时的模式与配置继续计奖。',
  'activity.invite.inviterRewardLevel1': '一级好友（发给直接邀请人）',
  'activity.invite.inviterRewardLevel2': '二级好友',
  'activity.invite.inviterRewardLevel3': '三级好友',
  'activity.invite.level1': '一级',
  'activity.invite.level2': '二级',
  'activity.invite.level3': '三级',
  'activity.invite.levelN': '{n}级',
  'activity.invite.firstDepositIntervalTitle': '首充金额区间奖励',
  'activity.invite.firstDepositRange': '首充金额区间（{{coin}}）',
  'activity.invite.andAbove': '及以上',
  'activity.invite.addFirstDepositInterval': '新增首充区间',
  'activity.invite.firstDepositIntervalHint': '好友达到有效会员定义时，按其首次充值那一笔的金额命中区间发奖；区间不重叠、不留空档，最高区间为"及以上"。现金 = 首充金额 x 命中区间该层比例，与「单人最高发放金额」按层封顶取小。',
  'activity.invite.firstDepositCashReward': '现金奖励（首充金额 x 比例）',
  'activity.invite.firstDepositCap': '单人最高发放金额',
  'activity.invite.firstDepositCapHint': '按层级封顶，全区间共用；发放 = min(首充金额 x 比例, 该级封顶)。未配置（0）表示该层不设封顶。',

  'activity.invite.rebateSetting': '返佣设置',
  'activity.invite.rebateSettingHint': '返佣生效 = 本活动启用 且 在优惠生效时间内 且 本开关开启，任一不满足即停止新的返佣计算（已发放不受影响）。本处配置修改仅对修改后新邀请的会员生效，已邀请会员按其被邀请时的配置继续计佣。',
  'activity.invite.rebateEnabled': '返佣总开关',
  'activity.invite.rebateLevel': '返佣层级',
  'activity.invite.autoIssueThreshold': '发放方式',
  'activity.invite.autoIssueThresholdPrefix': '自动到主账户；单笔现金 ≥',
  'activity.invite.autoIssueThresholdSuffix': '{{coin}} 停留待发放，由运营在返佣记录的计算详情弹窗内 确定发放 / 拒绝',
  'activity.invite.rebateMethodDeposit': '充值返佣',
  'activity.invite.rebateMethodBet': '投注返佣',
  'activity.invite.rebateMethodWinLoss': '输赢返佣',
  'activity.invite.rebateMethodHint': '返佣方式四选一，对同一会员同时只生效一种；切换后自下一期起全员改走新方式。',
  'activity.invite.rebateMethodNgr': 'NGR 返佣',
  'activity.invite.ngrRuleHint': '半月结（每月 01–15 / 16–月末，期末次日出账）。会员个人 NGR = 本人 GGR − 本人领取优惠（含佣金，全额扣减）− 本人积分兑换现金；本期佣金 = 各层好友个人 NGR 合计 × 该层比例（可为负互抵）；应发 = 本期佣金 + 上期结转，为负不发放、结转下期抵扣、不从余额扣回。比例/倍数/阈值修改在下一次结算时生效。',
  'activity.invite.ngrLevelRatio': '{{n}}级比例',
  'activity.invite.ngrCashTurnoverMultiple': '现金流水倍数（0 = 直接可提）',
  'activity.invite.ngrAutoIssueThreshold': '审核阈值',
  'activity.invite.ngrAutoIssueThresholdSuffix': '{{coin}} 停留待发放（人工审核），小于阈值自动发放',
  'activity.invite.depositThreshold': '门槛（昨日一级好友充值合计 ≥ {{coin}}）',
  'activity.invite.betThreshold': '门槛（昨日一级好友有效投注合计 ≥ {{coin}}）',
  'activity.invite.winLossThreshold': '门槛（当月一级好友净输赢合计 ≥ {{coin}}）',
  'activity.invite.betVenueScope': '计佣场馆范围',
  'activity.invite.rebateTierIndex': '档位',
  'activity.invite.addRebateTier': '新增档位',
  'activity.invite.rebateTierHint': '判档：以"一级好友（直属）当期基数合计"命中最高满足档，整组三层比例生效；低于最低档门槛 = 不命中、当期不产生返佣。',
  'activity.invite.rebateFootnote': '基数：按一至三级全部好友计算（不限定有效）；四级及更深的好友不计入任何奖励与返佣基数。',
  'activity.invite.dailyRebateCap': '单日返佣封顶金额（按层级）',
  'activity.invite.monthlyRebateCap': '单月返佣封顶金额（按层级）',
  'activity.invite.rebateCapHint': '每层现金 = min(该层基数 x 该层比例, 该层封顶)，超出按封顶发；只限现金，积分/参与券/大转盘照发。未配置（0）表示该层不设封顶。',

  'activity.chickActivity.userQuery.title': '用户状态查询',
  'activity.chickActivity.userQuery.userQuery': '用户查询',
  'activity.chickActivity.userQuery.userQueryPlaceholder': 'UID / 手机号',
  'activity.chickActivity.userQuery.search': '查询',
  'activity.chickActivity.userQuery.reset': '重置',
  'activity.chickActivity.userQuery.enterUserQuery': '请输入用户UID或手机号',
  'activity.chickActivity.userQuery.userNotFound': '未找到该用户',
  'activity.chickActivity.userQuery.searchUserFailed': '查询用户失败，请稍后重试',
  'activity.chickActivity.userQuery.queryUserStateFailed': '查询用户状态失败',
  'activity.chickActivity.userQuery.queryUserStateFailedRetry': '查询用户状态失败，请稍后重试',
  'activity.chickActivity.userQuery.queryRewardRecordsFailed': '查询奖励记录失败',
  'activity.chickActivity.userQuery.queryRewardRecordsFailedRetry': '查询奖励记录失败，请稍后重试',
  'activity.chickActivity.userQuery.stateOverview': '活动状态总览',
  'activity.chickActivity.userQuery.chickState': '孵化状态',
  'activity.chickActivity.userQuery.energy': '体力值',
  'activity.chickActivity.userQuery.todayBetCount': '今日有效投注次数',
  'activity.chickActivity.userQuery.currentPool': '当前奖池（如有）',
  'activity.chickActivity.userQuery.currency': '币种：',
  'activity.chickActivity.userQuery.poolTotal': 'pool_total:',
  'activity.chickActivity.userQuery.poolRemaining': 'pool_remaining:',
  'activity.chickActivity.userQuery.chestPending': '宝箱待领取（按币种）',
  'activity.chickActivity.userQuery.item': '项目',
  'activity.chickActivity.userQuery.value': '值',
  'activity.chickActivity.userQuery.stateEnumReference': '状态枚举参考：EGG_INCUBATING / EGG_READY / HATCHED_NO_ENERGY / WORKING / HUNGRY / SICK',
  'activity.chickActivity.userQuery.rewardRecords': '奖励与签到记录',
  'activity.chickActivity.userQuery.date': '日期',
  'activity.chickActivity.userQuery.time': '时间',
  'activity.chickActivity.userQuery.type': '类型',
  'activity.chickActivity.userQuery.reward': '奖励',
  'activity.chickActivity.userQuery.status': '状态',
  'activity.chickActivity.userQuery.noData': '暂无数据',
  'activity.chickActivity.userQuery.rewardType.depositCheckin': '存款签到',
  'activity.chickActivity.userQuery.rewardType.freeCheckin': '免费签到',
  'activity.chickActivity.userQuery.rewardType.workReward': '打工奖励',
  'activity.chickActivity.userQuery.rewardType.energyCheckin': '能量签到',
  'activity.chickActivity.userQuery.rewardType.dailyBetMilestone': '投注里程碑-当日',
  'activity.chickActivity.userQuery.rewardType.weeklyBetMilestone': '投注里程碑-当周',
  'activity.chickActivity.userQuery.rewardType.unknown': '类型',
  'activity.chickActivity.userQuery.awardStatus.pending': '待领取',
  'activity.chickActivity.userQuery.awardStatus.claimed': '已领取',
  'activity.chickActivity.userQuery.awardStatus.expired': '已过期',
  'activity.chickActivity.userQuery.awardStatus.unknown': '未知',
  'activity.chickActivity.userQuery.chickState.eggIncubating': '孵化中',
  'activity.chickActivity.userQuery.chickState.eggReady': '准备孵化',
  'activity.chickActivity.userQuery.chickState.hatchedNoEnergy': '已孵化无体力',
  'activity.chickActivity.userQuery.chickState.working': '工作中',
  'activity.chickActivity.userQuery.chickState.hungry': '饥饿',
  'activity.chickActivity.userQuery.chickState.sick': '生病',
  'activity.chickActivity.userQuery.chickState.idle': '空闲',
  'activity.chickActivity.userQuery.chickState.hatching': '孵化中',
  'activity.chickActivity.userQuery.chickState.almostHatched': '即将孵化',
  'activity.chickActivity.userQuery.chickState.full': '满体力',
  'activity.chickActivity.userQuery.chickState.tired': '疲惫',
  'activity.chickActivity.userQuery.chickState.exhausted': '虚弱',
  'activity.chickActivity.userQuery.times': '次',
  'activity.chickActivity.userQuery.points': 'points',

  'activity.chickActivity.report.title': '数据报表（汇总）',
  'activity.chickActivity.report.dateRange': '日期范围',
  'activity.chickActivity.report.selectDateRange': '请选择日期范围',
  'activity.chickActivity.report.search': '查询',
  'activity.chickActivity.report.reset': '重置',
  'activity.chickActivity.report.queryDataFailed': '查询数据失败',
  'activity.chickActivity.report.queryDataFailedRetry': '查询数据报表失败，请稍后重试',
  'activity.chickActivity.report.statsDescription': '统计口径（需求冻结版）',
  'activity.chickActivity.report.participantCountDesc': '参与人数：当日进入活动页面并点击孵化任务或领取奖励的去重用户数（不以 cookie 口径）。',
  'activity.chickActivity.report.depositUserCountDesc': '活动存款人数：当日参与活动且至少一笔存款的去重用户数。',
  'activity.chickActivity.report.treasureBoxIssuedDesc': '宝箱发放：当日写入宝箱的现金类奖励金额，按币种分别统计（PHP / USDT / VND）。',
  'activity.chickActivity.report.treasureBoxClaimedDesc': '宝箱领取：当日从宝箱成功领取的现金类奖励金额，按币种分别统计。',
  'activity.chickActivity.report.treasureBoxExpiredDesc': '宝箱过期：当日到期未领的现金类奖励金额，按币种分别统计（24h 规则，按达成时间归属）。',
  'activity.chickActivity.report.amountPrecision': '金额精度',
  'activity.chickActivity.report.amountPrecisionDesc': '金额精度：现金统一保留 2 位小数，第 3 位直接截断。积分小数点后数字直接截断。',
  'activity.chickActivity.report.date': '日期',
  'activity.chickActivity.report.participantCount': '参与人数',
  'activity.chickActivity.report.depositUserCount': '活动存款人数',
  'activity.chickActivity.report.depositCheckinClaimCount': '存款签到领取人数',
  'activity.chickActivity.report.depositCheckinPointsIssued': '存款签到领取积分',
  'activity.chickActivity.report.freeCheckinClaimCount': '免费签到领取人数',
  'activity.chickActivity.report.freeCheckinPointsIssued': '免费签到领取积分',
  'activity.chickActivity.report.energyCheckinClaimCount': '能量签到领取人数',
  'activity.chickActivity.report.energyCheckinPointsIssued': '能量签到领取积分',
  'activity.chickActivity.report.treasureBoxIssued': '宝箱发放',
  'activity.chickActivity.report.treasureBoxClaimed': '宝箱领取',
  'activity.chickActivity.report.treasureBoxClaimedCount': '宝箱领取人数',
  'activity.chickActivity.report.treasureBoxExpired': '宝箱过期',
  'activity.chickActivity.report.dailyMilestoneIssued': '里程碑发放(当日)',
  'activity.chickActivity.report.dailyMilestoneClaimed': '里程碑领取(当日)',
  'activity.chickActivity.report.dailyMilestoneExpired': '里程碑过期(当日)',
  'activity.chickActivity.report.weeklyMilestoneIssued': '里程碑发放(当周)',
  'activity.chickActivity.report.weeklyMilestoneClaimed': '里程碑领取(当周)',
  'activity.chickActivity.report.weeklyMilestoneExpired': '里程碑过期(当周)',

  // 新返水优惠模板翻译
  'activity.newRebate.title': '新返水优惠设置',
  'activity.newRebate.firstDepositRebate': '首充投注返水',
  'activity.newRebate.vipRebate': 'VIP投注返水',
  'activity.newRebate.tieredRebate': '阶梯投注返水',
  'activity.newRebate.firstDepositAmount': '首充数额≥',
  'activity.newRebate.enterFirstDepositAmount': '请输入首充数额',
  'activity.newRebate.validDays': '有效天数',
  'activity.newRebate.enterValidDays': '请输入有效天数',
  'activity.newRebate.rebateType': '返水类型',
  'activity.newRebate.selectRebateType': '请选择返水类型',
  'activity.newRebate.cash': '现金',
  'activity.newRebate.point': '积分',
  'activity.newRebate.rebatePercent': '返水比例',
  'activity.newRebate.enterRebatePercent': '请输入返水比例',
  'activity.newRebate.truncateNotice': '返水比例支持小数点后两位；返水金额保留2位小数，超出部分直接舍弃（不四舍五入），不足0.01的奖励将舍弃不派发。适用于首充/VIP/阶梯投注返水的现金返水，积分返水不受影响。',
  'activity.newRebate.maxRebateCash': '當日最高返水现金',
  'activity.newRebate.maxRebatePoint': '最高返水积分',
  'activity.newRebate.enterMaxRebate': '请输入最高返水金额',
  'activity.newRebate.turnover': '流水倍數',
  'activity.newRebate.enterTurnover': '请输入流水',
  'activity.newRebate.vipLevel': 'VIP等级',
  'activity.newRebate.selectVipLevel': '请选择VIP等级',
  'activity.newRebate.bettingTurnover': '投注流水≥',
  'activity.newRebate.enterBettingTurnover': '请输入投注流水',
  'activity.newRebate.vipLevelMin': '最小等级',
  'activity.newRebate.vipLevelMax': '最大等级',
  'activity.newRebate.addRule': '新增',
  'activity.newRebate.deleteRule': '删除',
  'activity.newRebate.gamePlatform': '游戏平台',
  'activity.newRebate.ruleIndex': '规则 {{index}}',
  'activity.newRebate.tierIndex': '阶梯 {{index}}',
  'activity.newRebate.atLeastOneRule': '保存时至少需要一笔配置（现金或积分）',
  'activity.newRebate.maxRuleLimit': '最多只能配置一笔现金和一笔积分',
  'activity.newRebate.vipLevelConflict': '该VIP等级已被其它配置使用',
  'activity.newRebate.duplicateTurnoverType': '同一投注流水档次下，已存在相同返水类型的配置',
  'activity.newRebate.atLeastOneGameType': '至少勾选一个游戏类型',
  'activity.newRebate.gameType.1': '电子游戏',
  'activity.newRebate.gameType.2': '真人游戏',
  'activity.newRebate.gameType.3': '体育游戏',
  'activity.newRebate.gameType.4': '彩票游戏',
  'activity.newRebate.gameType.5': '捕鱼游戏',
  'activity.newRebate.gameType.6': '棋牌游戏',
  'activity.newRebate.gameType.7': '电竞游戏',
  'activity.newRebate.gameType.8': '小游戏',
  'activity.newRebate.gameType.9': '竞猜游戏',
  'activity.newRebate.gameType.10': '电竞游戏',
  'activity.newRebate.gameType.11': '街机游戏',
  'activity.newRebate.gameType.12': '宾果游戏',
  'activity.newRebate.distributeMode': '派发方式',
  'activity.newRebate.distributeModeDirect': '直接派发到用户账户',
  'activity.newRebate.distributeModeDirectDesc': '返水结算时，现金入主账户、积分入积分账户，自动到账',
  'activity.newRebate.distributeModeCoupon': '派发至优惠中心待领取',
  'activity.newRebate.distributeModeCouponDesc': '返水结算时，奖励出现在优惠中心，用户手动领取后到账',

  'activity.newRebate.gameGroupRebate': '游戏组返水',
  'activity.newRebate.gameGroup.create': '+ 新建游戏组',
  'activity.newRebate.gameGroup.createTitle': '新建游戏组',
  'activity.newRebate.gameGroup.syncIcons': '同步游戏图标',
  'activity.newRebate.gameGroup.syncIconsTooltip': '从游戏库（默认语言 langGame.h5Img）批量同步所有「可选游戏池」的图标到 iconUrl，前端日报水接口的 games[].iconUrl 据此下发。',
  'activity.newRebate.gameGroup.syncIconsConfirmTitle': '确认同步所有可选游戏的图标？',
  'activity.newRebate.gameGroup.syncIconsConfirmContent': '将从游戏库批量拉取默认语言的 h5Img 回填，仅更新与旧值不同的条目。运行通常 < 5 秒。',
  'activity.newRebate.gameGroup.syncIconsRunning': '正在同步…',
  'activity.newRebate.gameGroup.syncIconsResultTitle': '同步完成',
  'activity.newRebate.gameGroup.syncIconsSummary': '总计 {{total}} / 命中 {{matched}} / 更新 {{updated}} / 跳过 {{skipped}}',
  'activity.newRebate.gameGroup.syncIconsSkippedTitle': '跳过明细（请运营到游戏库默认语言下补 h5Img）',
  'activity.newRebate.gameGroup.syncIconsSkippedColPlatform': '平台',
  'activity.newRebate.gameGroup.syncIconsSkippedColGameCode': '游戏编号',
  'activity.newRebate.gameGroup.syncIconsSkippedColReason': '原因',
  'activity.newRebate.gameGroup.syncIconsFailed': '同步失败，请检查网络或后端日志',
  'activity.newRebate.gameGroup.iconNotSynced': '未同步图标，请点击「同步游戏图标」批量回填',
  'activity.newRebate.gameGroup.iconLoadFailed': '图标 URL 已同步但加载失败（可能 404 或路径异常），请联系运营核对游戏库 h5Img',
  'activity.newRebate.gameGroup.editTitle': '编辑游戏组',
  'activity.newRebate.gameGroup.basicInfo': '基础信息',
  'activity.newRebate.gameGroup.gamesInGroup': '组内游戏',
  'activity.newRebate.gameGroup.gamesInGroupHint': '同一游戏同一时间只能归属一个组；已占用的游戏置灰',
  'activity.newRebate.gameGroup.name': '组名称',
  'activity.newRebate.gameGroup.namePlaceholder': '如：新游主推 · PG狂欢',
  'activity.newRebate.gameGroup.coverImg': '封面',
  'activity.newRebate.gameGroup.coverImgPlaceholder': '建议 120×120 JPG/PNG，请填写图片 URL',
  'activity.newRebate.gameGroup.coverImgHint': '建议 120×120 JPG/PNG/WEBP，单张不超过 2MB',
  'activity.newRebate.gameGroup.startDate': '开始日期',
  'activity.newRebate.gameGroup.endDate': '结束日期',
  'activity.newRebate.gameGroup.percent': '返水比例',
  'activity.newRebate.gameGroup.percentPlaceholder': '请输入返水比例',
  'activity.newRebate.gameGroup.maxRebate': '当天上限',
  'activity.newRebate.gameGroup.maxRebatePlaceholder': '请输入当天上限',
  'activity.newRebate.gameGroup.turnoverMultiplier': '流水倍数',
  'activity.newRebate.gameGroup.turnoverMultiplierPlaceholder': '请输入流水倍数',
  'activity.newRebate.gameGroup.timeRange': '限定时间',
  'activity.newRebate.gameGroup.timeRangeHint': '选填；留空即长期有效。设置后开始时间到自动上架，结束时间到自动下架。',
  'activity.newRebate.gameGroup.sortNo': '排序',
  'activity.newRebate.gameGroup.searchGame': '搜索游戏名称…',
  'activity.newRebate.gameGroup.expandAll': '展开全部',
  'activity.newRebate.gameGroup.collapseAll': '收起全部',
  'activity.newRebate.gameGroup.selectAllPlatform': '全选此厂商',
  'activity.newRebate.gameGroup.gamesCount': '共 {{count}} 款',
  'activity.newRebate.gameGroup.selectedCount': '已勾选 {{count}} 款游戏',
  'activity.newRebate.gameGroup.occupied': '已占用',
  'activity.newRebate.gameGroup.atLeastOneGame': '请至少勾选一款游戏',
  'activity.newRebate.gameGroup.emptySource': '暂无可选游戏，请先到「游戏池」维护可选游戏',
  'activity.newRebate.gameGroup.noMatchedGame': '没有匹配的游戏',
  'activity.newRebate.gameGroup.emptyList': '尚未配置游戏组',
  'activity.newRebate.gameGroup.listSubtitle': '运营自由创建组别；组内游戏的流水仅计入本组，不再计入阶梯返水',
  'activity.newRebate.gameGroup.tipDeduct': '流水归属（核心规则）：被划入任一游戏组的游戏，其流水仅计入该组，不再计入阶梯投注返水所属游戏类型（电子/真人/体育/捕鱼）的阶梯流水。',
  'activity.newRebate.gameGroup.tipUnique': '唯一归属：同一款游戏同一时间只能加入一个组；新建/编辑弹窗里，已被其他组占用的游戏会显示「已占用」并置灰。',
  'activity.newRebate.gameGroup.tipDeductTitle': '流水归属（核心规则）',
  'activity.newRebate.gameGroup.tipDeductDesc': '被划入任一游戏组的游戏，其流水仅计入该组，不再计入阶梯投注返水所属游戏类型（电子/真人/体育/捕鱼）的阶梯流水。',
  'activity.newRebate.gameGroup.tipUniqueTitle': '唯一归属',
  'activity.newRebate.gameGroup.tipUniqueDesc': '同一款游戏同一时间只能加入一个组；新建/编辑弹窗里，已被其他组占用的游戏会显示「已占用」并置灰。',
  'activity.newRebate.gameGroup.noCover': '无封面',
  'activity.newRebate.gameGroup.longTerm': '长期有效',
  'activity.newRebate.gameGroup.status': '状态',
  'activity.newRebate.gameGroup.statusOf.online': '上架中',
  'activity.newRebate.gameGroup.statusOf.upcoming': '未开始',
  'activity.newRebate.gameGroup.statusOf.offline': '已下架',
  'activity.newRebate.gameGroup.statusOf.manualOff': '手动下架',
  'activity.newRebate.gameGroup.operation': '操作',
  'activity.newRebate.gameGroup.edit': '编辑',
  'activity.newRebate.gameGroup.delete': '删除',
  'activity.newRebate.gameGroup.unpublish': '下架',
  'activity.newRebate.gameGroup.publish': '上架',
  'activity.newRebate.gameGroup.deleteConfirm': '确认删除该游戏组？',
  'activity.newRebate.gameGroup.deleteSuccess': '已删除',
  'activity.newRebate.gameGroup.confirmOk': '确定',
  'activity.newRebate.gameGroup.cancel': '取消',
  'activity.newRebate.gameGroup.save': '保存',

  // 信息绑定优惠模板翻译
  'activity.infoBinding.conditionSettings': '条件设置',
  'activity.infoBinding.serialNumber': '序号',
  'activity.infoBinding.enterSerialNumber': '请输入序号',
  'activity.infoBinding.serialNumberMustBePositive': '序号必须大于0',
  'activity.infoBinding.authInfoType': '当认证信息=',
  'activity.infoBinding.selectAuthInfoType': '请选择认证信息',
  'activity.infoBinding.authInfo.mobileTask': '手机认证任务与奖励',
  'activity.infoBinding.authInfo.emailTask': '邮箱认证任务与奖励',
  'activity.infoBinding.authInfo.withdrawPasswordTask': '提现密码任务与奖励',
  'activity.infoBinding.authInfo.kycTask': 'KYC任务与奖励',
  'activity.infoBinding.authInfo.downloadAppTask': '下载APP任务与奖励',
  'activity.infoBinding.authInfo.appLoginMobileVerifiedTask': 'APP登入成功且手机验证成功',
  'activity.infoBinding.excludeMember.title': '不派发奖励会员名单',
  'activity.infoBinding.excludeMember.manage': '管理排除名单',
  'activity.infoBinding.excludeMember.memberAccount': '会员账号',
  'activity.infoBinding.excludeMember.createUserName': '操作人',
  'activity.infoBinding.excludeMember.createTime': '创建时间',
  'activity.infoBinding.excludeMember.searchPlaceholder': '请输入账号搜索',
  'activity.infoBinding.excludeMember.upload': '上传 CSV',
  'activity.infoBinding.excludeMember.uploadTitle': '批量导入排除账号',
  'activity.infoBinding.excludeMember.downloadTemplate': '下载模板',
  'activity.infoBinding.excludeMember.uploadHint': 'CSV 格式：第一行为表头（memberAccount），后续行为账号',
  'activity.infoBinding.excludeMember.deleteSuccess': '删除成功',
  'activity.infoBinding.excludeMember.uploadSuccess': '上传成功',
  'activity.infoBinding.excludeMember.operation': '操作',
  'activity.infoBinding.excludeMember.deleteConfirm': '确认删除该记录吗？',
  'activity.infoBinding.excludeMember.confirmOk': '确定',
  'activity.infoBinding.excludeMember.delete': '删除',
  'activity.infoBinding.excludeMember.search': '搜索',
  'activity.infoBinding.excludeMember.total': '共',
  'activity.infoBinding.excludeMember.saveFirst': '请先保存活动后再管理名单',
  'activity.infoBinding.rewardDistribution': '则派发',
  'activity.infoBinding.rewardType': '奖励类型',
  'activity.infoBinding.pointAmount': '积分数量',
  'activity.infoBinding.enterPointAmount': '请输入积分数量',
  'activity.infoBinding.pointAmountMustBePositive': '积分数量必须大于0',
  'activity.infoBinding.addPointReward': '添加积分奖励',
  'activity.infoBinding.cashAmount': '现金金额',
  'activity.infoBinding.enterCashAmount': '请输入现金金额',
  'activity.infoBinding.cashAmountMustBeNonNegative': '现金金额不能为负数',
  'activity.infoBinding.desireMultiple': '流水倍数',
  'activity.infoBinding.enterDesireMultiple': '请输入流水倍数',
  'activity.infoBinding.cashRequiresMultiple': '现金奖励大于0时需要设置流水倍数',
  'activity.infoBinding.addCashReward': '添加现金奖励',
  'activity.infoBinding.otherSettings': '其他设置',
  'activity.infoBinding.riskControlConditions': '风控条件',
  'activity.infoBinding.selectRiskControlLevel': '选择风控等级',
  'activity.infoBinding.taskSwitch': '任务开关',
  'activity.infoBinding.selectAuthType': '选择任务类型',
  'activity.infoBinding.selectAuthTypePlaceholder': '请选择任务类型',
  'activity.infoBinding.selectAuthTypeFirst': '请先选择任务类型',

  // 小鸡活动
  'chickActivity.activityConfig': '活动配置',
  'chickActivity.dataReport': '数据报表',
  'chickActivity.userQuery': '用户状态查询',

  // 活动配置页面
  'chickActivity.activityBasic': '活动基础',
  'chickActivity.activityStatus': '活动状态',
  'chickActivity.enabled': '启用',
  'chickActivity.disabled': '停用',
  'chickActivity.enabledHint': '启用后对所有用户生效',
  'chickActivity.activityTime': '活动时间',
  'chickActivity.userScope': '适用用户范围',
  'chickActivity.userScopeDesc': '所有用户（活动期间登录即创建鸡蛋并参与）',
  'chickActivity.readonly': '只读',
  'chickActivity.autoHatchTime': '自动孵化时间',
  'chickActivity.autoHatchTimeDesc': '72 小时（超时自动孵化，体力=0）',
  'chickActivity.systemDefault': '系统默认',
  'chickActivity.systemRules': '系统规则（只读）',
  'chickActivity.systemRule1': '体力共 7 格；存款当日恢复满格；每日无存款 -1。',
  'chickActivity.systemRule2': '体力 4–7 可触发打工返利；体力 0（Sick）出现免费签到。',
  'chickActivity.systemRule3': '每次存款生成新的返利池（pool_total 重新计算），并重新计算对应打工奖励。',
  'chickActivity.systemRule4': '宝箱奖励有效期 24 小时，未领取则失效。',
  'chickActivity.systemRule5': '跨天写入口径：当日达成但次日写入宝箱，仍归属达成当日；有效期从达成时间起算 24h。',
  'chickActivity.systemRule6': '金额精度：保留 2 位小数，第 3 位直接截断（不四舍五入）。',
  'chickActivity.globalRebateRatio': '全局返利比例',
  'chickActivity.globalRebateRatioExample': '示例：存款 1000P → pool_total = 8P',
  'chickActivity.workPoolRebateRatio': '打工奖池返利比例（%）',
  'chickActivity.workPoolRebateRatioDesc': '每次存款 × 该比例 = 新奖池 pool_total',
  'chickActivity.poolMaxAmount': '奖池最大额度',
  'chickActivity.poolMaxAmountDesc': '单次存款生成的奖池上限（超过则按上限计算）',
  'chickActivity.workPoolRatio': '奖励解锁前置条件（累计投注比例）',
  'chickActivity.workPoolRatioExample': '累计有效投注金额 ≥ 奖池 × X% 后，才开始触发打工奖励',
  'chickActivity.rewardTurnoverMultiple': '奖励现金流水倍数',
  'chickActivity.rewardTurnoverMultipleDesc': '用于现金奖励的提现流水要求（倍数）',

  // 新手孵化任务
  'chickActivity.hatchTasks': '新手孵化任务',
  'chickActivity.taskOnceOnly': '每任务仅可完成一次',
  'chickActivity.hatchTaskDesc': '任务名称直接展示「多语言编辑」入口；奖励为减少孵化剩余时间（小时）。',
  'chickActivity.taskNameMultiLang': '任务名称（多语言）',
  'chickActivity.taskName': '任务名称',
  'chickActivity.enterTaskName': '请输入任务名称',
  'chickActivity.taskDesc': '任务描述',
  'chickActivity.enterTaskDesc': '请输入任务描述',
  'chickActivity.editTaskName': '编辑任务名称（多语言）',
  'chickActivity.rewardHours': '奖励（减少孵化时长）',
  'chickActivity.directHatch': '直接孵化（系统规则）',
  'chickActivity.hours': '小时',
  'chickActivity.completionCondition': '完成条件（只读说明）',
  // 完成条件说明（按 taskKey，孵化任务与能量任务共用）
  'chickActivity.taskCondition.bind_phone': '完成一次手机号绑定',
  'chickActivity.taskCondition.bind_email': '完成一次邮箱绑定',
  'chickActivity.taskCondition.kyc_verify': '完成一次 KYC 认证',
  'chickActivity.taskCondition.name_chick': '首次为小鸡命名',
  'chickActivity.taskCondition.app_login': '完成APP登入',
  'chickActivity.taskCondition.first_deposit': '完成首笔存款',
  'chickActivity.taskCondition.invite_valid_friend': '邀请有效好友',

  // 能量获取任务
  'chickActivity.energyTasks': '能量获取任务',
  'chickActivity.energyTaskDesc': '能量获取任务配置，支持一次性任务和每日任务。奖励为获取的能量值。',
  'chickActivity.energyTaskType': '任务类型',
  'chickActivity.energyTaskTypeOnce': '一次性任务',
  'chickActivity.energyTaskTypeDaily': '每日任务',
  'chickActivity.rewardEnergy': '奖励能量',
  'chickActivity.energyUnit': '能量',
  'chickActivity.rewardPoints': '奖励积分',

  // 存款签到
  'chickActivity.depositCheckin': '存款签到（按体力 7 日）',
  'chickActivity.currentCurrency': '当前币种',
  'chickActivity.addTier': '新增区间',
  'chickActivity.addWorkTier': '新增档位',
  'chickActivity.depositCheckinDesc': '奖励总额 = 存款金额 ×（区间「7日体力奖励总比例」）→ 按 D1–D7 曲线拆分（合计=100%）。',
  'chickActivity.amountTruncate': '金额截断：保留 2 位小数，第 3 位直接截取。最高档可配置「积分上限」（仅最高档生效）。',
  'chickActivity.depositRange': '存款区间',
  'chickActivity.rewardRatio': '7日体力奖励总比例(%)',
  'chickActivity.pointCap': '最高赠送积分上限（仅最高档）',
  'chickActivity.range': '区间',
  'chickActivity.total': '合计',
  'chickActivity.tierNote': '新增/删除区间会同步影响 D1–D7 曲线行；不同币种的区间与曲线互不影响。',

  // 免费签到
  'chickActivity.freeCheckin': '免费签到（Sick）',
  'chickActivity.freeCheckinDesc': '关停影响：体力=0 时不再出现免费签到入口；不影响存款签到与打工奖励。',
  'chickActivity.triggerCondition': '触发条件',
  'chickActivity.sickCondition': '体力 = 0（Sick）',
  'chickActivity.systemRule': '系统规则',
  'chickActivity.dailyLimit': '每日次数上限',
  'chickActivity.times': '次',
  'chickActivity.rewardRange': '奖励范围',
  'chickActivity.serverRandom': '由服务端随机',
  'chickActivity.readonlyDisplay': '只读展示',
  'chickActivity.restoreEnergy': '是否恢复体力',
  'chickActivity.no': '否',
  'chickActivity.fixed': '固定',

  // 打工奖励
  'chickActivity.workReward': '打工奖励（里程碑）',
  'chickActivity.poolTriggerOnce': '每个返利池触发一次',
  'chickActivity.workRewardDesc': '达成条件：当日累计有效投注次数 ≥ N 次，触发一次；取最高档发放。',
  'chickActivity.workRewardDesc2': '每档掉落笔数固定为 1；每次存款生成新 pool 后重新计算一次可触发档位。',
  'chickActivity.workRewardDescNew1': '每次存款都会生成一个新的打工奖池（pool），并从「奖池生成时间」开始累计奖励解锁前置条件，之后计算有效投注次数。',
  'chickActivity.workRewardDescNew2': '里程碑为【阶梯式】：每完成一档，即发放该档位奖励（默认 1 笔）；每档仅触发一次。',
  'chickActivity.workRewardDescNew3': '再次存款后，奖池按新的存款金额刷新，投注次数重新从 0 开始累计。',
  'chickActivity.workCondition': '达成条件（当日累计 ≥ N 次）',
  'chickActivity.accumulateReach': '累计达到',
  'chickActivity.dropCount': '掉落笔数',
  'chickActivity.rewardType': '派发奖励类型',
  'chickActivity.cash': '现金',
  'chickActivity.points': '积分',
  'chickActivity.poolToPointsRatio': '奖池兑积分比例',
  'chickActivity.cashToPointsRate': '每1单位现金兑换积分',
  'chickActivity.useGlobal': '使用全局',
  'chickActivity.tierRatioModalDesc': '为空则使用全局设置，设置后该档位将使用自定义比例',
  'chickActivity.tierRateModalDesc': '为空则使用全局设置，设置后该档位将使用自定义兑换比率',
  'chickActivity.workRewardTotalError': '打工奖励（里程碑）的总比例必须为100%，当前为{total}%',
  'chickActivity.depositCurveTotalError': '存款签到曲线验证失败：\n{errors}',

  // Jeepney Activity
  'jeepneyActivity.activityStatus': '活动状态',
  'jeepneyActivity.selectActivityStatus': '请选择活动状态',
  'jeepneyActivity.enabled': '启用',
  'jeepneyActivity.disabled': '停用',
  'jeepneyActivity.currency': '币种',
  'jeepneyActivity.selectCurrency': '请选择币种',
  'jeepneyActivity.activityTime': '活动开始结束时间',
  'jeepneyActivity.selectActivityTime': '请选择活动开始结束时间',
  'jeepneyActivity.rewardExpireDays': '奖励过期天数',
  'jeepneyActivity.rewardExpireDaysPlaceholder': '输入天数，-1表示不过期',
  'jeepneyActivity.enterRewardExpireDays': '请输入奖励过期天数',
  'jeepneyActivity.days': '天',
  'jeepneyActivity.riskControlLevel': '风控等级',
  'jeepneyActivity.selectRiskControlLevel': '选择风控等级',
  'jeepneyActivity.riskControl.restrictLogin': '限制登录',
  'jeepneyActivity.riskControl.restrictDeposit': '限制存款',
  'jeepneyActivity.riskControl.restrictClaim': '限制领取优化',
  'jeepneyActivity.riskControl.suspectedRisk': '疑似风险',
  'jeepneyActivity.riskControl.sameIpControl': '同IP风控',
  'jeepneyActivity.multiLanguage': '多语言',
  'jeepneyActivity.basicSettings': '基础设置',
  'jeepneyActivity.activityName': '活动名称',
  'jeepneyActivity.enterActivityName': '请输入活动名称',
  'jeepneyActivity.promotionName': '优惠名称',
  'jeepneyActivity.detailUrl': '详情地址',
  'jeepneyActivity.enterDetailUrl': '请输入详细地址',
  'jeepneyActivity.activityIntroduction': '活动简介',
  'jeepneyActivity.enterActivityIntroduction': '请输入活动简介',
  'jeepneyActivity.appIcon': 'APP图标',
  'jeepneyActivity.selectAppIcon': '请上传APP图标',
  'jeepneyActivity.h5Icon': 'H5图标',
  'jeepneyActivity.selectH5Icon': '请上传H5图标',
  'jeepneyActivity.pcIcon': 'PC图标',
  'jeepneyActivity.selectPcIcon': '请上传PC图标',
  'jeepneyActivity.imageUploadTip': '规范尺寸700*280 宽，支持.jpg .jpeg.png，大小不超过2M',
  
  // 赛道与奖励设置
  'jeepneyActivity.trackAndRewardSettings': '赛道与奖励设置',
  'jeepneyActivity.basicInfo': '基础信息',
  'jeepneyActivity.totalStages': '总关卡数',
  'jeepneyActivity.totalStagesRequired': '请输入总关卡数',
  'jeepneyActivity.totalStagesPlaceholder': '请输入总关卡数',
  'jeepneyActivity.totalStagesTip': '最后一关即终局关卡（无需单独配置终局关卡号）',
  'jeepneyActivity.totalStagesTimeLimit': '总关卡限时',
  'jeepneyActivity.sectionEndStages': '段尾关卡',
  'jeepneyActivity.sectionEndStagesPlaceholder': '请选择段尾关卡',
  'jeepneyActivity.sectionEndStagesTip': '段尾用于触发「段尾默认奖励」和「段尾预告弹窗」。手动选择后，会将表格中的段尾关卡标记',
  'jeepneyActivity.cashOutEnabledStages': '允许兑现关卡',
  'jeepneyActivity.cashOutEnabledStagesPlaceholder': '请输入允许兑现关卡',
  'jeepneyActivity.finalStageConsumption': '终关消耗',
  'jeepneyActivity.finalStageConsumptionPlaceholder': '请输入终关消耗',
  'jeepneyActivity.currencyAcquisitionMethods': '货币获取方式',
  'jeepneyActivity.currencyAcquisitionMethod': '货币获取方式',
  'jeepneyActivity.currencyMethod.invite': '邀请加油',
  'jeepneyActivity.currencyMethod.pointsExchange': '积分兑换',
  'jeepneyActivity.currencyMethod.recharge': '充值兑换',
  'jeepneyActivity.stages': '关',
  'jeepneyActivity.exchangeRatio': '兑换比例',
  'jeepneyActivity.minRechargeAmount': '充值金额 ≥',
  'jeepneyActivity.rewardValueType': '取值方式',
  'jeepneyActivity.rewardValueTypeRequired': '请选择取值方式',
  'jeepneyActivity.rewardValueType.fixed': '固定派发',
  'jeepneyActivity.rewardValueType.random': '随机派发',
  'jeepneyActivity.value': '值',
  'jeepneyActivity.currencyName': '货币名称',
  'jeepneyActivity.currencyNameRequired': '请输入货币名称',
  'jeepneyActivity.currencyNamePlaceholder': '请输入货币名称',
  'jeepneyActivity.buttonName': '按钮名称',
  'jeepneyActivity.buttonNameRequired': '请输入按钮名称',
  'jeepneyActivity.buttonNamePlaceholder': '请输入按钮名称',
  'jeepneyActivity.singleRoundCashCap': '单轮现金上限',
  'jeepneyActivity.currencyRequired': '请选择币种',
  'jeepneyActivity.amountRequired': '请输入金额',
  'jeepneyActivity.amount': '金额',
  'jeepneyActivity.stageConfig': '关卡配置',
  'jeepneyActivity.stageNumber': '关卡号',
  'jeepneyActivity.stageType': '关卡类型',
  'jeepneyActivity.stageType.normal': '普通',
  'jeepneyActivity.stageType.sectionEnd': '段尾',
  'jeepneyActivity.stageType.final': '终关',
  'jeepneyActivity.configSource': '奖励来源',
  'jeepneyActivity.configSource.default': '默认配置',
  'jeepneyActivity.configSource.manual': '手动配置',
  'jeepneyActivity.rewardType': '奖励类型',
  'jeepneyActivity.rewardContent': '奖励内容',
  'jeepneyActivity.notConfigured': '未配置',
  'jeepneyActivity.accumulatedConsumption': '累计消耗',
  'jeepneyActivity.actualConsumption': '实际消耗（差分）',
  'jeepneyActivity.distributionMethod': '派发方式',
  'jeepneyActivity.distributionMethod.all': '全部派发',
  'jeepneyActivity.distributionMethod.randomOne': '随机派发一个奖项',
  'jeepneyActivity.cashOutEnabled': '兑现本关奖励',
  'jeepneyActivity.defaultRewardSettings': '默认关卡设置',
  'jeepneyActivity.singleRoundPointsCap': '单轮积分上限',
  'jeepneyActivity.singleRoundPointsCapRequired': '请输入单轮积分上限',
  'jeepneyActivity.singleRoundPointsCapPlaceholder': '请输入单轮积分上限',
  'jeepneyActivity.singleRoundVoucherCap': '单轮单个卷上限',
  'jeepneyActivity.singleRoundVoucherCapRequired': '请输入单轮单个卷上限',
  'jeepneyActivity.singleRoundVoucherCapPlaceholder': '请输入单轮单个卷上限',
  'jeepneyActivity.singleRoundFuelCap': '单轮推进货币上限',
  'jeepneyActivity.singleRoundFuelCapRequired': '请输入单轮推进货币上限',
  'jeepneyActivity.singleRoundFuelCapPlaceholder': '请输入单轮推进货币上限',
  'jeepneyActivity.sectionEndStagesRequired': '请选择段尾关卡',
  'jeepneyActivity.minimumParticipationThreshold': '最低参与门槛',
  'jeepneyActivity.minimumParticipationThresholdRequired': '请输入最低参与门槛',
  'jeepneyActivity.minimumParticipationThresholdPlaceholder': '请输入最低参与门槛',
  'jeepneyActivity.globalCashTurnoverMultiplier': '全局现金流水倍数',
  'jeepneyActivity.globalCashTurnoverMultiplierRequired': '请输入全局现金流水倍数',
  'jeepneyActivity.globalCashTurnoverMultiplierPlaceholder': '请输入全局现金流水倍数',
  'jeepneyActivity.countdownSettings': '倒计时设置',
  'jeepneyActivity.countdownRuleTip': '限时增加倒计时内，没有完成任何一个限时任务，则会重新开启下一轮。',
  'jeepneyActivity.timedTaskCountdown': '限时任务倒计时',
  'jeepneyActivity.duration': '时长',
  'jeepneyActivity.durationRequired': '请输入倒计时时长',
  'jeepneyActivity.hours': '小时',
  'jeepneyActivity.minutes': '分钟',
  'jeepneyActivity.seconds': '秒',
  'jeepneyActivity.allowAllCompletion': '允许全部完成',
  'jeepneyActivity.allowAllCompletionTip': '若关闭，完成了一个则会消失该显示任务入口，下一轮倒计时结束则会重新显示全新的任务',
  'jeepneyActivity.rechargeTasks': '充值任务',
  'jeepneyActivity.inviteFriends': '邀请好友',
  'jeepneyActivity.inviteFriendType': '邀请好友类型',
  'jeepneyActivity.inviteValidFriends': '有效好友',
  'jeepneyActivity.inviteRegisteredFriends': '注册好友',
  'jeepneyActivity.registeredUsers': '注册人数',
  'jeepneyActivity.peopleCount': '人数',
  'jeepneyActivity.peopleCountRequired': '请输入人数',
  'jeepneyActivity.rewardValuePerInstance': '每次奖励取值',
  'jeepneyActivity.rewardValue': '奖励取值',
  'jeepneyActivity.pointsExchange': '积分兑换',
  'jeepneyActivity.consumePoints': '消耗积分',
  'jeepneyActivity.consumePointsRequired': '请输入消耗积分',
  'jeepneyActivity.dailyPurchaseLimit': '每日限购次数',
  'jeepneyActivity.dailyPurchaseLimitRequired': '请输入每日限购次数',
  'jeepneyActivity.testRechargeCount': '充值试算次数',
  'jeepneyActivity.testInviteCount': '邀请试算人数',
  'jeepneyActivity.unit': '单位',
  'jeepneyActivity.unitRequired': '请选择单位',
  'jeepneyActivity.rechargeAmount': '充值金额 ≥',
  'jeepneyActivity.timeIncrease': '倒计时增加',
  'jeepneyActivity.timeIncreaseRequired': '请输入倒计时增加',
  'jeepneyActivity.inviteTasks': '邀请任务',
  'jeepneyActivity.validFriends': '邀请有效好友',
  'jeepneyActivity.validFriendsRequired': '请输入邀请有效好友数',
  'jeepneyActivity.countdownConfigTip': '运营配置时需避免配置多条相近门槛导致体验混乱(建议门槛阶梯清晰、加时差异明确)。',
  'jeepneyActivity.fuelConsumptionWarning': '表格中修改，会根据当前关卡填写的值更新后续所有的累计消耗，并重新计算实际消耗',
  'jeepneyActivity.pleaseSetTotalStages': '请先设置总关卡数',
  'jeepneyActivity.defaultRewardConfig': '默认关卡设置',
  'jeepneyActivity.entryReward': '入场奖励',
  'jeepneyActivity.entryRewardApplied': '入场奖励应用完的内容',
  'jeepneyActivity.notSet': '未设置',
  'jeepneyActivity.defaultReward': '关卡设置',
  'jeepneyActivity.rewardConfig': '奖励配置',
  'jeepneyActivity.rewardTypeDuplicate.points': '积分只能出现一次',
  'jeepneyActivity.rewardTypeDuplicate.fuel': '推进货币只能出现一次',
  'jeepneyActivity.cashCurrencyDuplicate': '现金同币种只能出现一次',
  'jeepneyActivity.ticketTypeDuplicate': '大转盘同类型只能出现一次',
  'jeepneyActivity.rewardTypeRequired': '请选择奖励类型',
  'jeepneyActivity.rewardType.cash': '现金',
  'jeepneyActivity.rewardType.points': '积分',
  'jeepneyActivity.rewardType.spinTicket': '大转盘卷',
  'jeepneyActivity.rewardType.fuel': '推进货币',
  'jeepneyActivity.rewardType.none': '无',
  'jeepneyActivity.turntableType': '转盘类型',
  'jeepneyActivity.turntableTypeRequired': '请选择转盘类型',
  'jeepneyActivity.turntable1': '大转盘1',
  'jeepneyActivity.turntable2': '大转盘2',
  'jeepneyActivity.rewardValueType': '奖励取值',
  'jeepneyActivity.valueRequired': '请输入值',
  'jeepneyActivity.minValue': '最小值',
  'jeepneyActivity.minValueRequired': '请输入最小值',
  'jeepneyActivity.maxValue': '最大值',
  'jeepneyActivity.maxValueRequired': '请输入最大值',
  'jeepneyActivity.defaultRewardWarning': '注意:客户端点一次推进按钮必定前进1关,避免点了不动,未配置将无法进行游戏',
  'jeepneyActivity.currencyConsumptionStrategy': '货币消耗策略',
  'jeepneyActivity.rewardDistributionStrategy': '奖励派策略',
  'jeepneyActivity.startingConsumption': '起步消耗',
  'jeepneyActivity.startingConsumptionRequired': '请输入起步消耗',
  'jeepneyActivity.incrementalStep': '递增步长',
  'jeepneyActivity.incrementalStepRequired': '请输入递增步长',
  'jeepneyActivity.randomDistributionFormulaGeneration': '随机派发公式生成',
  'jeepneyActivity.rewardProgressionPerStage': '奖励随关卡推进',
  'jeepneyActivity.stagesPerIncrease': '每过 N 关',
  'jeepneyActivity.stagesPerIncreaseRequired': '请输入每过 N 关',
  'jeepneyActivity.stagesPerIncreaseMin': '必须大于0',
  'jeepneyActivity.minValueIncrease': '最小值增加',
  'jeepneyActivity.minValueIncreaseRequired': '请输入最小值增加',
  'jeepneyActivity.maxValueIncrease': '最大值增加',
  'jeepneyActivity.maxValueIncreaseRequired': '请输入最大值增加',
  'jeepneyActivity.rewardProgressionHint': '建议:最小值不应超过最大值;区间越宽随机感越强。',
  'jeepneyActivity.tailStageMultiplierValue': '段尾倍率值',
  'jeepneyActivity.tailStageMultiplier': '段尾倍率',
  'jeepneyActivity.sectionEndMultiplier': '段尾倍率',
  'jeepneyActivity.tailRewardMultiplier': '段尾奖励x',
  'jeepneyActivity.tailStageMultiplierDesc': '段尾关卡把奖励内容乘以设置值',
  'jeepneyActivity.tailStageMultiplierTip': '段尾关卡把奖励内容乘以设置值',
  'jeepneyActivity.sectionEndMultiplierTip': '段尾关卡把奖励内容乘以设置值',
  'jeepneyActivity.finalStageMultiplierValue': '终局倍率值',
  'jeepneyActivity.finalMultiplier': '终局倍率',
  'jeepneyActivity.finalStageMultiplier': '终局倍率',
  'jeepneyActivity.finalRewardMultiplier': '终局奖励x',
  'jeepneyActivity.finalStageMultiplierDesc': '最后一关把奖励内容乘以设置值',
  'jeepneyActivity.finalMultiplierTip': '最后一关把奖励内容乘以设置值',
  'jeepneyActivity.safetyUpperLimit': '安全上限 (最大值不超过)',
  'jeepneyActivity.safetyUpperLimitRequired': '请输入安全上限',
  'jeepneyActivity.safetyUpperLimitDesc': '说明:生成结果会被限制不超过上限。填0表示不启用上限。',
  'jeepneyActivity.safetyCap': '安全上限（最大值不超过）',
  'jeepneyActivity.safetyCapTip': '说明:生成结果会被限制不超过上限。填0表示不启用上限。',
  'jeepneyActivity.previewAutoRefresh': '预览 (自动刷新)',
  'jeepneyActivity.currentStage': '当前关卡',
  'jeepneyActivity.stage': '关卡',
  'jeepneyActivity.stageType': '关卡类型',
  'jeepneyActivity.autoGenerate': '自动生成',
  'jeepneyActivity.autoGenerateFixed': '自动生成(固定)',
  'jeepneyActivity.autoGenerateRandom': '自动生成(随机)',
  'jeepneyActivity.manualGenerate': '手动生成',
  'jeepneyActivity.randomReward': '随机奖励：数值在范围内随机生成',
  'jeepneyActivity.rewardColorTip.fixed': '表示固定奖励，数值固定不变',
  'jeepneyActivity.rewardColorTip.random': '表示随机奖励，数值在范围内随机生成',
  'jeepneyActivity.actualConsumptionNegativeWarning': '实际消耗为负值，除终关外视为异常，将阻止保存',
  'jeepneyActivity.stageType.normal': '普通',
  'jeepneyActivity.stageType.tail': '段尾',
  'jeepneyActivity.stageType.final': '终关',
  'jeepneyActivity.result': '结果 (对应的奖励)',
  'jeepneyActivity.minValueExceedsMax': '最小值不应超过最大值',
  'jeepneyActivity.multiplierLessThanOne': '放大倍数不能小于1',
  'jeepneyActivity.multiplierMin': '必须大于等于1',
  'jeepneyActivity.abnormalStatusMessage': '异常状态:最小值大于最大值、或增长节奏为0、或放大倍数小于1时,保存校验阻断并提示。',
  'jeepneyActivity.finalStageConsumptionTooltip': '默认实际消耗 = 本关累计门槛 - 上关累计门槛 (第1关减0)\n•1~N关:累计门槛必须严格递增\n•终关N:累计门槛必须≥上一关(允许相等=终关差分为0)\n•任意关卡差分消耗不得为负(系统计算)\n•人为单关修改单关、终关实际消耗不受默认配置影响。\n注意:客户端点一次推进按钮必定前进1关,避免点了不动,未配置将无法进行游戏',
  'jeepneyActivity.finalStageConsumptionRequired': '请输入终关消耗',
  'jeepneyActivity.distributionMethodRequired': '请选择派发方式',
  'jeepneyActivity.turnoverMultiple': '流水',
  'jeepneyActivity.turnoverMultipleRequired': '请输入流水倍数',
  'jeepneyActivity.times': '倍',
  'jeepneyActivity.vipLevel': 'VIP等级',
  'jeepneyActivity.allowedCashOutStages': '允许兑现关卡',
  'jeepneyActivity.rewardSyncStrategy': '奖励同步策略',
  'jeepneyActivity.rewardSyncStrategyRequired': '请选择奖励同步策略',
  'jeepneyActivity.rewardSyncStrategy.coverAll': '覆盖全部关卡',
  'jeepneyActivity.rewardSyncStrategy.merge': '合并奖励',
  'jeepneyActivity.configMethod': '配置方式',
  'jeepneyActivity.configMethodRequired': '请选择配置方式',
  'jeepneyActivity.configMethod.autoGenerate': '自动生成',
  'jeepneyActivity.configMethod.manual': '手动',
  'jeepneyActivity.firstStageValue': '值',
  'jeepneyActivity.firstStageValueRequired': '请输入值',
  'jeepneyActivity.firstStageMinValueRequired': '请输入最小值',
  'jeepneyActivity.firstStageMaxValueRequired': '请输入最大值',
  'jeepneyActivity.rewardConfigTip': '每关配置建议实际估算,人工核对',
  'jeepneyActivity.useDefaultConfig': '使用默认配置',
  'jeepneyActivity.stageRewardConfig': '单关奖励配置',
  'jeepneyActivity.generationRule': '生成规则',
  'jeepneyActivity.generateRandomRule': '生成随机规则',
  'jeepneyActivity.generateFixedRule': '生成固定规则',
  'jeepneyActivity.fixedDistributionFormulaGeneration': '固定派发公式生成',
  'jeepneyActivity.fixedIncrease': '固定增加',
  'jeepneyActivity.fixedIncreaseRequired': '请输入固定增加',
  'jeepneyActivity.fixedIncreasePerPeriod': '每个周期固定增加的值',
  'jeepneyActivity.growthPeriod': '增长周期',
  'jeepneyActivity.roundingMethod': '取整方式',
  'jeepneyActivity.roundingMethodRequired': '请选择取整方式',
  'jeepneyActivity.roundingMethod.round': '四舍五入',
  'jeepneyActivity.roundingMethod.ceil': '向上取整',
  'jeepneyActivity.roundingMethod.floor': '向下取整',
  'jeepneyActivity.actualConsumptionStrategy': '实际消耗策略',
  'jeepneyActivity.consumptionStrategy.fixed': '固定',
  'jeepneyActivity.consumptionStrategy.incremental': '递增',
  'jeepneyActivity.inheritDefaultConsumption': '继承默认消耗',
  'jeepneyActivity.finalStageConsumptionEditTip': '不会影响其他关卡,只修改实际消耗',
  'jeepneyActivity.settlementSettings': '结算设置',
  'jeepneyActivity.settlementThreshold': '结算门槛',
  'jeepneyActivity.settlementThresholdTypeRequired': '请选择结算门槛类型',
  'jeepneyActivity.completeFinalStage': '完成终关',
  'jeepneyActivity.occurredInRound': '本轮至少发生过',
  'jeepneyActivity.rechargeAmountRequired': '请输入充值金额',
  'jeepneyActivity.inviteValidUsers': '邀请有效人数≥',
  'jeepneyActivity.inviteValidUsersRequired': '请输入邀请有效人数',
  'jeepneyActivity.settlementFailureSettings': '结算失败设置',
  'jeepneyActivity.settlementFailureTaskSettings': '结算失败任务设置',
  'jeepneyActivity.settlementFailureTaskRuleTip': '运营配置时需确保失败次数阶梯清晰，避免同一失败次数配置多条造成理解混乱。',
  'jeepneyActivity.failureCount': '失败次数',
  'jeepneyActivity.failureCountRequired': '请选择失败次数',
  'jeepneyActivity.inviteValidFriends': '邀请有效好友',
  'jeepneyActivity.inviteValidFriendsRequired': '请输入邀请有效好友数',
  'jeepneyActivity.noRechargeTasks': '暂无充值任务配置，请点击"新增"添加',
  'jeepneyActivity.noInviteTasks': '暂无邀请任务配置，请点击"新增"添加',
  'jeepneyActivity.weightCalculation': '权重计算',
  'jeepneyActivity.rechargeWeight': '充值每次权重',
  'jeepneyActivity.rechargeWeightRequired': '请输入充值每次权重',
  'jeepneyActivity.inviteWeight': '有效邀请每人权重',
  'jeepneyActivity.inviteWeightRequired': '请输入有效邀请每人权重',
  'jeepneyActivity.dynamicProbability': '动态概率',
  'jeepneyActivity.round': '轮次',
  'jeepneyActivity.baseProbability': '基础概率(%)',
  'jeepneyActivity.baseProbabilityRequired': '请输入基础概率',
  'jeepneyActivity.weightConversionFactor': '权重转换系数',
  'jeepneyActivity.weightConversionFactorRequired': '请输入权重转换系数',
  'jeepneyActivity.failureIncreasePerTime': '失败每次增加(%)',
  'jeepneyActivity.failureIncreasePerTimeRequired': '请输入失败每次增加',
  'jeepneyActivity.failureIncreaseCap': '失败增加上限(%)',
  'jeepneyActivity.failureIncreaseCapRequired': '请输入失败增加上限',
  'jeepneyActivity.minProbability': '最小概率(%)',
  'jeepneyActivity.minProbabilityRequired': '请输入最小概率',
  'jeepneyActivity.maxProbability': '最大概率(%)',
  'jeepneyActivity.maxProbabilityRequired': '请输入最大概率',
  'jeepneyActivity.actualProbability': '实际概率',
  'jeepneyActivity.noDynamicProbabilityRounds': '暂无动态概率配置，请点击"新增"添加',
  'jeepneyActivity.roundExplanation': '仅在完成终关(第N关)后轮次+1,中途兑现不计入轮次。',
  'common.yes': '是',
  'common.no': '否',
  'common.edit': '编辑',
  'common.apply': '应用',
  'common.on': '开',
  'common.off': '关',
  'common.allow': '允许',
  'common.disallow': '不允许',
  'common.confirm': '确定',

  // ===== Jeepney 多币种改版新增 =====
  'jeepneyActivity.addCurrency': '币种',
  'jeepneyActivity.currencyPending': '待填',
  'jeepneyActivity.removeCurrencyGroup': '移除该币种',
  'jeepneyActivity.keepAtLeastOneCurrency': '至少保留一个币种',
  'jeepneyActivity.currencyHint': '勾选的币种在各金额行内亮起输入位并必填；至少保留一个币种',
  'jeepneyActivity.removeCurrencyConfirm': '取消后该币种已填写的全部金额配置将清除，且该币种玩家将不再看到本活动，确认取消?',
  'jeepneyActivity.confirmRemoveCurrency': '确认取消',
  'jeepneyActivity.thinkAgain': '再想想',
  'jeepneyActivity.cashRowOnlyOne': '现金类型只能新增一行',
  'jeepneyActivity.currencyGroupIncomplete': '请补全各币种的配置',
  'jeepneyActivity.allCurrenciesShared': '全币种共用',
  'jeepneyActivity.currencyConfigRecharge': '充值金额≥（按币种）',
  'jeepneyActivity.currencyConfigFriends': '有效好友（按币种）',
  'jeepneyActivity.currencyConfigRechargeTime': '币种配置（充值金额≥ + 倒计时增加）',
  'jeepneyActivity.currencyConfigFriendsTime': '币种配置（邀请有效好友 + 倒计时增加）',
  'jeepneyActivity.currencyConfigRechargeFuel': '币种配置（充值金额≥ + 派油量）',
  'jeepneyActivity.rechargeGte': '充值≥',
  'jeepneyActivity.addTime': '加时',
  'jeepneyActivity.fuel': '油',
  'jeepneyActivity.friends': '好友',
  'jeepneyFunnelAnalysis.currency': '币种',
  'jeepneyFunnelAnalysis.currencyAll': '全部',
  'jeepneyUserList.crossCurrencyNoSum': '不同币种金额不汇总，请筛选单一币种查看总成本与回报率',
  'jeepneyActivity.selectCurrencyFirst': '请先在基础设置勾选币种',
  'jeepneyActivity.allCurrenciesAdded': '已勾选的币种都已添加',
  'jeepneyActivity.minAmount': '金额≥',
  'jeepneyFunnelAnalysis.statisticsDate': '统计日期',
  'jeepneyFunnelAnalysis.dateSelect': '请选择日期',
  'jeepneyFunnelAnalysis.fixedForToday': '固定统计至今日',
  // 投注里程碑（当日 / 当周）
  'chickActivity.dailyBetMilestone': '投注里程碑（当日）',
  'chickActivity.weeklyBetMilestone': '投注里程碑（当周）',
  'chickActivity.dailyBetMilestoneDesc': '达成即写入宝箱，用户需手动领取；不设独立 24 小时倒计时；次日 00:00 新任务开启，上一天已达成未领取的奖励自动作废；不设体力门槛，体力 = 0（Sick）也可参与。',
  'chickActivity.weeklyBetMilestoneDesc': '达成即写入宝箱，用户需手动领取；不设独立 24 小时倒计时；次周一 00:00 新一周任务开启，上周已达成未领取的奖励自动作废；不设体力门槛。',
  'chickActivity.dailyTemplateHint': ' — {amount}/{reward} 自动取本行的门槛和奖励值，全表共用一个模板。',
  'chickActivity.weeklyTemplateHint': ' — {amount}/{reward} 自动取本行的门槛和奖励值，全表共用一个模板。',
  'chickActivity.newBadge': '新增',
  'chickActivity.copyPreview': '文案预览（自动生成）',
  'chickActivity.autoGenReadonly': '自动生成，不可编辑',
  'chickActivity.milestoneCondition': '达成条件',
  'chickActivity.currencyThreshold': '多币种门槛',
  'chickActivity.rewardValue': '奖励数值',
  'chickActivity.turnoverMultiple': '流水倍数',
  'chickActivity.copyTemplateMultiLang': '文案模板（多语言）',
  'chickActivity.templatePlaceholderHint': '可使用占位符：{amount}（达成门槛）、{reward}（奖励数值），全表共用同一模板。',
  'chickActivity.globalCurrencySettings': '全局多币种设置',
  'chickActivity.globalRateHint': '设置 1 单位 {base} 对应各币种的换算数值；档位「使用全局」时按此换算门槛。',
  'chickActivity.ratePerBase': '1 {base} =',
  'chickActivity.baseCurrencyHint': '各档位以 {base} 为基准配置；其余币种默认按上方全局设置换算，单档也可自行覆盖。',
  'chickActivity.currencyThresholdSettings': '多币种门槛设置',
  'chickActivity.currencyThresholdModalDesc': '为空则该币种使用全局换算；填写后该档位对应币种使用自定义门槛。',
  'chickActivity.threshold': '门槛',
  'chickActivity.resetToGlobal': '重置为使用全局',
  'chickActivity.addTierSlot': '新增档位',
  'chickActivity.notConfigured': '未配置',
  'chickActivity.selectCurrency': '选择币种',
  'chickActivity.milestoneCurrencyHint': '各币种档位独立配置，切换上方币种即可编辑对应币种的档位；不同币种互不影响。',
  'chickActivity.milestoneRuleEnergy': '投注里程碑不设体力门槛，任意体力值（含 0 / Sick）均可参与累计和领取。',
  'chickActivity.milestoneRuleClaim': '投注里程碑达成后写入宝箱，用户需手动领取；不设独立 24 小时倒计时——当日 0 点 / 每周一 0 点新一轮任务开启时，上一轮已达成但未领取的奖励自动作废。',

  // 通用 - 星期
  'common.weekday.monday': '周一',
  'common.weekday.tuesday': '周二',
  'common.weekday.wednesday': '周三',
  'common.weekday.thursday': '周四',
  'common.weekday.friday': '周五',
  'common.weekday.saturday': '周六',
  'common.weekday.sunday': '周日',

  // 红包活动
  'redPacket.title': '红包设置',
  'redPacket.name': '红包名称',
  'redPacket.enterName': '请输入红包名称',
  'redPacket.ruleTitle': '规则标题',
  'redPacket.enterRuleTitle': '请输入规则标题',
  'redPacket.ruleContent': '规则说明',
  'redPacket.enterRuleContent': '请输入规则说明',
  'redPacket.currency': '币种',
  'redPacket.selectCurrency': '请选择币种',
  'redPacket.addRedPacket': '添加红包',
  'redPacket.editRedPacket': '编辑红包',
  'redPacket.createSuccess': '创建成功',
  'redPacket.updateSuccess': '更新成功',
  'redPacket.hasIssueRecordsTip': '该活动已有发放记录，用户类型、统计周期、事项类型、发放类型、发放方式、红包金额范围不可修改，仅可修改名称、发放时间、领取时效等。',
  'redPacket.deleteSuccess': '删除成功',
  'redPacket.confirmDelete': '确定要删除该红包活动吗？',
  'redPacket.dataLoadFailed': '数据加载失败',
  'redPacket.operation': '操作',

  'redPacket.stats.title': '红包雨统计',
  'redPacket.stats.redPacketName': '红包名称',
  'redPacket.stats.distributionTime': '发放时间',
  'redPacket.stats.distributionMethod': '发放方式',
  'redPacket.stats.userCount': '发放用户',
  'redPacket.stats.totalAmount': '实发金额',
  'redPacket.stats.settings': '设置',
  'redPacket.stats.viewMemberList': '查看名单',
  'redPacket.stats.memberAccount': '会员账号',
  'redPacket.stats.amount': '金额',
  'redPacket.stats.claimTime': '领取时间',
  'redPacket.stats.exportMemberList': '导出名单',
  'redPacket.stats.loadFailed': '加载失败',
  'redPacket.stats.memberListLoadFailed': '名单加载失败',

  'redPacket.distributionType.label': '发放类型',
  'redPacket.distributionType.daily': '每日发放',
  'redPacket.distributionType.weekly': '每周发放',
  'redPacket.distributionType.monthly': '每月发放',
  'redPacket.distributionType.specified': '指定发放',
  'redPacket.selectDistributionType': '请选择发放类型',

  'redPacket.distributionTime': '发放时间',
  'redPacket.selectDistributionTime': '请选择发放时间',
  'redPacket.weekDay': '星期',
  'redPacket.selectWeekDay': '请选择星期',
  'redPacket.monthDay': '日期',
  'redPacket.selectMonthDay': '请选择日期',
  'redPacket.time': '时间',
  'redPacket.selectTime': '请选择时间',

  'redPacket.distributionMethod.label': '发放方式',
  'redPacket.distributionMethod.scheduled': '定时领取',
  'redPacket.distributionMethod.popup': '弹窗领取',
  'redPacket.distributionMethod.autoCredit': '登录自动到账',
  'redPacket.selectDistributionMethod': '请选择发放方式',

  'redPacket.claimValidity': '领取时效',
  'redPacket.enterValidityValue': '请输入时效数值',
  'redPacket.selectValidityUnit': '请选择单位',
  'redPacket.validityUnit.minute': '分钟',
  'redPacket.validityUnit.day': '天',

  'redPacket.amountRange': '单个红包发放区间',
  'redPacket.amountConfig': '红包金额配置',
  'redPacket.minAmount': '最小金额',
  'redPacket.enterMinAmount': '请输入最小金额',
  'redPacket.maxAmount': '最大金额',
  'redPacket.enterMaxAmount': '请输入最大金额',

  'redPacket.userType.label': '用户类型',
  'redPacket.userType.nonFirstDeposit': '非首充用户',
  'redPacket.userType.nonfirstdeposit': '非首充用户',
  'redPacket.userType.firstDeposit': '首充用户',
  'redPacket.userType.firstdeposit': '首充用户',
  'redPacket.userType.specifiedUser': '指定用户',
  'redPacket.userType.specifieduser': '指定用户',
  'redPacket.selectUserType': '请选择用户类型',
  'redPacket.userConfig': '用户类型配置',

  'redPacket.uploadMemberList': '上传名单',
  'redPacket.uploadMemberListTip': '请上传CSV文件，格式：第一行为表头 memberAccount，后续每行一个账号',
  'redPacket.memberListRequired': '请上传用户名单',
  'redPacket.memberCount': '共 {count} 人',
  'redPacket.specifiedUsers': '指定用户',

  'redPacket.statisticsTime': '统计时间',
  'redPacket.statisticsConfig': '统计时间配置',
  'redPacket.statisticsCycle.label': '统计周期',
  'redPacket.statisticsCycle.weekly': '每周',
  'redPacket.statisticsCycle.monthly': '每月',
  'redPacket.selectStatisticsCycle': '请选择统计周期',
  'redPacket.userTypeStatisticsCycle.label': '用户类型统计周期',
  'redPacket.statisticsStartDay': '统计起始日',
  'redPacket.selectStartDay': '请选择起始日',
  'redPacket.statisticsEndDay': '统计结束日',
  'redPacket.selectEndDay': '请选择结束日',
  'redPacket.statisticsEffectiveTime.label': '统计生效时间',
  'redPacket.turnoverMultiple.label': '流水倍数',
  'redPacket.turnoverMultiple.placeholder': '请输入流水倍数',
  'redPacket.turnoverMultiple.required': '请输入流水倍数',
  'redPacket.statisticsEffectiveTime.placeholder': '请选择统计生效时间',
  'redPacket.statisticsEffectiveTime.tooltip': '设置后，仅统计该时间点之后的数据，防止历史数据被纳入统计',
  'redPacket.statisticsRange': '统计区间',

  'redPacket.cycleMismatchWeekly': '统计周期为每周时，红包发放只能选择每日发放或每周发放',
  'redPacket.cycleMismatchMonthly': '统计周期为每月时，红包发放只能选择每月发放或指定发放',

  'redPacket.eventType.label': '事项类型',
  'redPacket.eventType.deposit': '充值',
  'redPacket.eventType.bet': '投注',
  'redPacket.eventType.negativeProfit': '负盈利',
  'redPacket.eventType.negativeprofit': '负盈利',
  'redPacket.eventType.negative_profit': '负盈利',
  'redPacket.eventType.balance': '存款余额',
  'redPacket.selectEventType': '请选择事项类型',
  'redPacket.addEventType': '添加事项',
  'redPacket.eventTypeConfig': '事项类型配置',
  'redPacket.eventTypeRequired': '请至少添加一个事项类型',

  // FBMPLAY-1737 阶梯配置
  'redPacket.tier.section': '阶梯配置',
  'redPacket.tier.title': '档位',
  'redPacket.tier.add': '添加档位',
  'redPacket.tier.remove': '删除该档位',
  'redPacket.tier.conditionMin': '条件最小金额',
  'redPacket.tier.conditionMax': '条件最大金额',
  'redPacket.tier.noLimitPlaceholder': '留空表示无上限',
  'redPacket.tier.noLimit': '无上限',
  'redPacket.tier.rewardMin': '发放最小金额',
  'redPacket.tier.rewardMax': '发放最大金额',
  'redPacket.tier.required': '请至少设置一个档位',
  'redPacket.tier.conditionMinRequired': '请输入条件最小金额',
  'redPacket.tier.conditionMaxRequired': '请输入条件最大金额（仅末档可留空）',
  'redPacket.tier.conditionRangeInvalid': '条件最小金额不能大于条件最大金额',
  'redPacket.tier.rewardRequired': '请输入发放最小/最大金额',
  'redPacket.tier.rewardRangeInvalid': '发放最小金额不能大于发放最大金额',
  'redPacket.tier.multipleRequired': '请输入流水倍数',
  'redPacket.tier.overlap': '条件最小金额必须大于上一档的条件最大金额（档位需递增且不重叠）',
  'redPacket.tier.hint': '事项类型全档位共用；各档条件区间需递增且不重叠，末档最大金额留空表示无上限；用户按达标的最高档位领取',
  'redPacket.tier.legacyHint': '此活动为旧版配置（复合事项/固定金额），版本更新后不再计算；请重新设置事项类型与阶梯档位后保存',
  'redPacket.tier.legacyTag': '旧版',

  'redPacket.distributionConfig': '发放配置',

  // 宝箱管理
  'treasureBox.config.title': '宝箱设置',
  'treasureBox.config.activityStatus': '活动状态',
  'treasureBox.config.enabled': '启用',
  'treasureBox.config.disabled': '停用',
  'treasureBox.config.activityThreshold': '活跃度门槛',
  'treasureBox.config.activityThresholdDesc': '每天24点后，随机派发宝箱给用户，用户的小鸡签到活跃度 ≥ 该值',
  'treasureBox.config.dailyBoxLimit': '每日宝箱上限',
  'treasureBox.config.dailyBoxLimitDesc': '每24小时最多发放的宝箱数量',
  'treasureBox.config.levelConfig': '宝箱等级配置',
  'treasureBox.config.levelName': '等级名称',
  'treasureBox.config.dropRate': '获取概率(%)',
  'treasureBox.config.expireHours': '开启时效(小时)',
  'treasureBox.config.prizeConfig': '奖品配置(彩金)',
  'treasureBox.config.flowMultiple': '流水倍数',
  'treasureBox.config.setup': '设置',
  'treasureBox.config.save': '保存',
  'treasureBox.config.saveSuccess': '保存成功',
  'treasureBox.config.saveFailed': '保存失败',
  'treasureBox.config.loadFailed': '加载配置失败',
  'treasureBox.config.dropRateSumError': '所有等级的获取概率总和必须为100%，当前为{total}%',
  'treasureBox.config.enableGuard': '启用前请确保：获取概率合计 100%，且概率大于 0 的等级都已配置彩金区间',
  'treasureBox.config.statusUpdateSuccess': '状态更新成功',
  'treasureBox.config.statusUpdateFailed': '状态更新失败',
  'treasureBox.config.prizeConfigTitle': '奖品彩金配置',
  'treasureBox.config.minAmount': '最小金额',
  'treasureBox.config.maxAmount': '最大金额',
  'treasureBox.config.probability': '概率(%)',
  'treasureBox.config.addRange': '添加区间',
  'treasureBox.config.prizeProbSumError': '所有彩金区间概率总和必须为100%，当前为{total}%',
  'treasureBox.config.currentPrize': '当前奖品区间',

  'treasureBox.level.WOOD': '木宝箱',
  'treasureBox.level.IRON': '铁宝箱',
  'treasureBox.level.BRONZE': '青铜宝箱',
  'treasureBox.level.SILVER': '白银宝箱',
  'treasureBox.level.GOLD': '黄金宝箱',
  'treasureBox.level.DIAMOND': '钻石宝箱',

  'treasureBox.stats.title': '宝箱统计',
  'treasureBox.stats.dateRange': '日期范围',
  'treasureBox.stats.search': '查询',
  'treasureBox.stats.reset': '重置',
  'treasureBox.stats.levelName': '等级名称',
  'treasureBox.stats.statsDate': '统计日期',
  'treasureBox.stats.coinCode': '币种',
  'treasureBox.records.coinCode': '币种',
  'treasureBox.stats.grantCount': '发放数',
  'treasureBox.stats.openCount': '开启数',
  'treasureBox.stats.expiredCount': '已过期数',
  'treasureBox.stats.totalPrizeAmount': '累计发放奖励',
  'treasureBox.stats.keyGrantCount': '钥匙发放数',
  'treasureBox.stats.keyUsedCount': '钥匙已使用数',
  'treasureBox.stats.timeRequired': '请选择日期范围',
  'treasureBox.stats.queryFailed': '查询统计数据失败',

  'treasureBox.records.title': '宝箱派发记录',
  'treasureBox.records.boxId': '宝箱ID',
  'treasureBox.records.memberAccount': '会员账号',
  'treasureBox.records.memberInfoId': '用户ID',
  'treasureBox.records.keyId': '钥匙ID',
  'treasureBox.records.levelCode': '宝箱等级',
  'treasureBox.records.grantTime': '派发时间',
  'treasureBox.records.expireTime': '过期时间',
  'treasureBox.records.openTime': '开启时间',
  'treasureBox.records.openKeyId': '开启钥匙编号',
  'treasureBox.records.prizeAmount': '发放奖励',
  'treasureBox.records.flowMultiple': '流水倍数',
  'treasureBox.records.tradeNo': '交易号',
  'treasureBox.records.search': '查询',
  'treasureBox.records.reset': '重置',
  'treasureBox.records.queryFailed': '查询派发记录失败',
  'treasureBox.records.selectLevel': '请选择宝箱等级',
  'treasureBox.records.allLevels': '全部等级',
  'treasureBox.records.boxStatus': '宝箱状态',
  'treasureBox.records.boxStatus.pending': '待开启',
  'treasureBox.records.boxStatus.opened': '已开启',
  'treasureBox.records.boxStatus.expired': '已过期',
  'treasureBox.records.grantSource': '发放来源',
  'treasureBox.records.grantSource.autoGrant': '每日自动发放',
  'treasureBox.records.grantSource.activityReward': '活动奖励发放',
  'treasureBox.records.selectBoxStatus': '请选择宝箱状态',
  'treasureBox.records.selectGrantSource': '请选择发放来源',
  'treasureBox.records.timeRequired': '请至少选择一个时间范围',
  'treasureBox.records.keyDataPkCode': '开启钥匙编码',


  // Tab 标题

  // 游戏列表 (Tab1)

  // 派发 (Tab2) - 列表搜索

  // 派发 - 列表列

  // 派发 - 新增弹窗

  // 派发 - 批量导入弹窗

  // 派发 - 详情/重发

  // 批次状态

  // 明细

  // 明细状态

  // 统计

  // ===== 厂商排行榜活动 =====
  'activity.vendorLeaderboard.title': '厂商排行榜活动',
  'activity.vendorLeaderboard.boardConfigTitle': 'B·榜单配置',
  'activity.vendorLeaderboard.boardConfigTip': '每个榜单各自独立：游戏范围 / 会员 / 排名口径 / 奖励 / 派发，切换上方榜单分别配置。',
  'activity.vendorLeaderboard.addBoard': '新增榜单',
  'activity.vendorLeaderboard.board': '榜单',
  'activity.vendorLeaderboard.overallBoard': '总榜',
  'activity.vendorLeaderboard.unnamedBoard': '未命名榜单',
  'activity.vendorLeaderboard.confirmRemoveBoard': '确定删除该榜单？',
  'activity.vendorLeaderboard.boardBasic': '榜单基本',
  'activity.vendorLeaderboard.boardNameZh': '榜单名称（中）',
  'activity.vendorLeaderboard.boardNameZhTip': '前台页签中文名',
  'activity.vendorLeaderboard.boardNameEn': '榜单名称（英）',
  'activity.vendorLeaderboard.boardNameEnTip': '前台页签英文名',
  'activity.vendorLeaderboard.boardSort': '显示排序（前台页签顺序）',
  'activity.vendorLeaderboard.boardSortTip': '数值越小越靠前',
  'activity.vendorLeaderboard.boardBanner': '榜单横幅图（前台·本榜单独立）',
  'activity.vendorLeaderboard.boardBannerTip': '各端横幅图分别上传',
  'activity.vendorLeaderboard.bannerH5': 'H5 横幅',
  'activity.vendorLeaderboard.bannerPc': 'PC 横幅',
  'activity.vendorLeaderboard.bannerApp': 'App 横幅',
  'activity.vendorLeaderboard.gameScope': '榜单范围',
  'activity.vendorLeaderboard.gameScopeTip': '勾选本榜统计哪些游戏：品类 / 游戏平台 / 游戏 三级，父级半选表示部分选中。固定 6 品类，Sports 只到平台级、不细分玩法。',
  'activity.vendorLeaderboard.searchGame': '搜索游戏',
  'activity.vendorLeaderboard.catSlot': 'Slot（电子）',
  'activity.vendorLeaderboard.catCasino': 'Casino（真人）',
  'activity.vendorLeaderboard.catPoker': 'Poker（棋牌）',
  'activity.vendorLeaderboard.catBingo': 'Bingo（宾果）',
  'activity.vendorLeaderboard.catSports': 'Sports（体育）',
  'activity.vendorLeaderboard.catFish': 'Fish（捕鱼）',
  'activity.vendorLeaderboard.memberScope': '参与会员等级',
  'activity.vendorLeaderboard.joinMember': '参与会员',
  'activity.vendorLeaderboard.memberAll': '全部会员',
  'activity.vendorLeaderboard.memberVip': '指定 VIP 等级',
  'activity.vendorLeaderboard.vipLevels': 'VIP 等级',
  'activity.vendorLeaderboard.rankSource': '排名口径 & 数据源',
  'activity.vendorLeaderboard.metric': '排名指标',
  'activity.vendorLeaderboard.metricValidBet': '有效投注（投注榜）',
  'activity.vendorLeaderboard.metricProfit': '盈利额（赢钱榜）',
  'activity.vendorLeaderboard.metricLoss': '亏损额（输钱榜）',
  'activity.vendorLeaderboard.rankSourceTip': '数据源复用「用户排名」对应榜（投注 / 赢钱 / 输钱），周期含 实时（本期）+ 昨日（上期定榜），按自然周期统计（非滚动）。前台榜单数值列随指标显示为 有效投注 / 盈利额 / 亏损额。无效注、对冲、对打等由平台风控与数据层判定。',
  'activity.vendorLeaderboard.minThreshold': '最小上榜门槛（PHP）',
  'activity.vendorLeaderboard.minThresholdTip': '低于此有效投注不进榜',
  'activity.vendorLeaderboard.minBoardCount': '最低成榜人数',
  'activity.vendorLeaderboard.minBoardCountTip': '不足时空缺名次不发，防低流量套利',
  'activity.vendorLeaderboard.optional': '选填',
  'activity.vendorLeaderboard.rewardLadder': '奖励阶梯',
  'activity.vendorLeaderboard.importExcel': '上传 Excel',
  'activity.vendorLeaderboard.downloadTemplate': '下载模板',
  'activity.vendorLeaderboard.importTip': '模板字段：名次（或区间起 · 止）· 人数 · 奖励类型（现金 / 积分 / 大转盘券）· 奖励值 · 流水倍数（现金填）· 大转盘类型（券填）。导入覆盖当前阶梯。',
  'activity.vendorLeaderboard.importEmpty': '未解析到有效数据',
  'activity.vendorLeaderboard.importSuccess': '导入成功，共 {{count}} 档',
  'activity.vendorLeaderboard.importFail': '导入失败，请检查文件格式',
  'activity.vendorLeaderboard.enableRankRange': '启用名次区间',
  'activity.vendorLeaderboard.enableRankRangeTip': '默认每个名次单独配；开启后可按区间（如 4~10 名）批量配同一奖励',
  'activity.vendorLeaderboard.rank': '名次',
  'activity.vendorLeaderboard.count': '人数',
  'activity.vendorLeaderboard.rewardContent': '奖励内容（可多项）',
  'activity.vendorLeaderboard.rewardValue': '奖励值',
  'activity.vendorLeaderboard.rewardCash': '现金',
  'activity.vendorLeaderboard.rewardPoint': '积分',
  'activity.vendorLeaderboard.rewardSpinTicket': '大转盘券',
  'activity.vendorLeaderboard.flowLabel': '流水',
  'activity.vendorLeaderboard.times': '倍',
  'activity.vendorLeaderboard.selectSpinType': '选择转盘类型',
  'activity.vendorLeaderboard.addReward': '加奖励',
  'activity.vendorLeaderboard.addRank': '新增名次',
  'activity.vendorLeaderboard.operation': '操作',
  'activity.vendorLeaderboard.delete': '删除',
  'activity.vendorLeaderboard.settlement': '结算与发放',
  'activity.vendorLeaderboard.settleCycle': '结算周期（天）',
  'activity.vendorLeaderboard.settleCycleTip': '从榜单生效时间起算的天数（不绑自然周），每满 N 天定榜结算并重置',
  'activity.vendorLeaderboard.days': '天',
  'activity.vendorLeaderboard.boardTime': '榜单生效时间',
  'activity.vendorLeaderboard.boardTimeTip': '本榜单的开始 / 结束时间，必须落在活动基本生效时间范围内',
  'activity.vendorLeaderboard.errBoardTimeRequired': '榜单「{{name}}」请设置生效时间',
  'activity.vendorLeaderboard.errBoardTimeOrder': '榜单「{{name}}」开始时间须早于结束时间',
  'activity.vendorLeaderboard.errBoardTimeWithinActivity': '榜单「{{name}}」生效时间必须在活动生效时间范围内',
  'activity.vendorLeaderboard.errSettleCycle': '榜单「{{name}}」结算周期需为大于 0 的天数',
  'activity.vendorLeaderboard.tieRule': '平局规则',
  'activity.vendorLeaderboard.tieFirstReach': '先达到者优先',
  'activity.vendorLeaderboard.arrivalTiming': '到账时机',
  'activity.vendorLeaderboard.arrivalTimingFixed': '次日 16:00',
  'activity.vendorLeaderboard.arrivalTimingTip': '定榜后次日 16:00 前发放，系统写死',
  'activity.vendorLeaderboard.distributeMode': '派发方式',
  'activity.vendorLeaderboard.distributeDirect': '直接派发到用户账户',
  'activity.vendorLeaderboard.distributeClaim': '需用户领取',
  'activity.vendorLeaderboard.rewardExpireDays': '奖励过期天数（-1 不过期）',
  'activity.vendorLeaderboard.rewardExpireDaysTip': '-1 表示不过期',
  'activity.vendorLeaderboard.grantAudit': '发放审核',
  'activity.vendorLeaderboard.grantAuditTip': '开启 = 运营核对后发放；关闭 = 不核对自动发放',
  'activity.vendorLeaderboard.on': '开启',
  'activity.vendorLeaderboard.off': '关闭',
  'activity.vendorLeaderboard.activityRule': '活动规则（运营配置·本榜单独立）',
  'activity.vendorLeaderboard.ruleTip': '运营逐条填写活动规则，对标前台玩法说明。可增删条目，前台规则弹窗按顺序展示。中 / 英跟随语言各填一套。',
  'activity.vendorLeaderboard.ruleItems': '规则条目',
  'activity.vendorLeaderboard.ruleItemPlaceholder': '请输入规则条目',
  'activity.vendorLeaderboard.addRuleItem': '新增规则条目',
  'activity.vendorLeaderboard.errNoBoard': '请至少配置一个榜单',
  'activity.vendorLeaderboard.errBoardName': '榜单「{{name}}」中英文名称必填',
  'activity.vendorLeaderboard.errVip': '榜单「{{name}}」请选择 VIP 等级',
  'activity.vendorLeaderboard.errNoReward': '榜单「{{name}}」请至少配置一档奖励',
  'activity.vendorLeaderboard.errRewardValue': '榜单「{{name}}」奖励值需大于 0',
  'activity.vendorLeaderboard.errSpinTicket': '榜单「{{name}}」请选择大转盘类型',
  'activity.vendorLeaderboard.errLastBoard': '至少保留一个榜单',
  'activity.vendorLeaderboard.errRankOverlap': '榜单「{{name}}」名次有重复或重叠，请检查',
  'activity.vendorLeaderboard.rankConflictHint': '名次存在重复或重叠（已标红），每个名次只能配置一次，请调整后再保存',
  'fsBatch.platformCode': '平台代码',
  'fsBatch.currency': '币种',
  'fsBatch.batchNo': '批次号',
  'fsBatch.status': '状态',
  'fsBatch.query': '查询',
  'fsBatch.reset': '重置',
  'fsBatch.dispatchTime': '派发时间',
  'fsBatch.finishTime': '完成时间',
  'fsBatch.addDispatch': '新增派发',
  'fsBatch.games': '游戏',
  'fsBatch.rounds': '局数',
  'fsBatch.total': '总数',
  'fsBatch.expanded': '已生成',
  'fsBatch.progress': '进度',
  'fsBatch.action': '操作',
  'fsBatch.detail': '明细',
  'fsBatch.viewProgress': '查看进度',
  'fsBatch.refreshProgress': '刷新进度',
  'fsBatch.progressText': '成功 {{success}} / 失败 {{fail}} / 待处理 {{pending}}',
  'fsBatch.batchStatus.0': '创建',
  'fsBatch.batchStatus.1': '生成中',
  'fsBatch.batchStatus.2': '派发中',
  'fsBatch.batchStatus.3': '完成',
  'fsBatch.batchStatus.4': '部分失败',
  'fsBatch.batchStatus.5': '失败',
  'fsBatch.submitTitle': '新增免费旋转派发',
  'fsBatch.platformCodeRequired': '请输入平台代码',
  'fsBatch.platformCodePlaceholder': '如 SL_FC',
  'fsBatch.currencyRequired': '请选择币种',
  'fsBatch.currencyPlaceholder': '请选择币种',
  'fsBatch.gameIds': '游戏ID',
  'fsBatch.gameIdsRequired': '请选择游戏',
  'fsBatch.gameIdsPlaceholder': '选择游戏（支持多选）',
  'fsBatch.gameIdsEmpty': '请先选择平台代码，或到游戏列表中维护游戏',
  'fsBatch.roundsLabel': '派发局数',
  'fsBatch.roundsRequired': '请输入派发局数',
  'fsBatch.roundsPlaceholder': '每人派发的免费旋转局数',
  'fsBatch.denomination': '面值（可选）',
  'fsBatch.denominationPlaceholder': '留空则用游戏默认面值',
  'fsBatch.startTime': '开始时间（可选）',
  'fsBatch.startTimePlaceholder': '留空立即生效',
  'fsBatch.endTime': '结束时间',
  'fsBatch.endTimeRequired': '请选择结束时间',
  'fsBatch.endTimePast': '结束时间不能早于当前时间',
  'fsBatch.endBeforeStart': '结束时间必须晚于开始时间',
  'fsBatch.endTimePlaceholder': '有效期截止',
  'fsBatch.memberFile': '会员名单',
  'fsBatch.selectCsv': '选择 CSV 文件',
  'fsBatch.csvFormatHint': 'CSV 格式：首行表头，其后每行一个会员账号',
  'fsBatch.downloadTemplate': '下载模板',
  'fsBatch.remark': '备注（可选）',
  'fsBatch.remarkPlaceholder': '本次派发用途',
  'fsBatch.uploadRequired': '请上传会员名单 CSV 文件',
  'fsBatch.fileSizeLimit': '文件不能超过 30MB',
  'fsBatch.uploadFailed': '文件上传失败',
  'fsBatch.submitFailed': '提交失败',
  'fsBatch.submitSuccess': '派发任务已提交，批次号：{{batchNo}}',
  'fsBatch.taskTitle': '派发明细',
  'fsBatch.memberId': '会员账号',
  'fsBatch.vendorUsername': '三方账号',
  'fsBatch.currency': '币种',
  'fsBatch.attempt': '重试次数',
  'fsBatch.vendorTxId': '厂商事务号',
  'fsBatch.errorCode': '错误码',
  'fsBatch.errorMsg': '错误信息',
  'fsBatch.taskStatus.0': '待派发',
  'fsBatch.taskStatus.1': '处理中',
  'fsBatch.taskStatus.2': '成功',
  'fsBatch.taskStatus.3': '失败',
  'fsBatch.whitelistTab': '免费旋转游戏列表',
  'fsBatch.dispatchTab': '免费旋转派发',
  'fsBatch.wlId': 'ID',
  'fsBatch.wlGameId': '游戏ID',
  'fsBatch.wlGameName': '游戏名称',
  'fsBatch.wlUpdateTime': '更新时间',
  'fsBatch.wlEnabled': '启用',
  'fsBatch.wlDisabled': '停用',
  'fsBatch.wlEnable': '启用',
  'fsBatch.wlDisable': '停用',
  'fsBatch.wlDelete': '删除',
  'fsBatch.wlAdd': '新增',
  'fsBatch.wlAddTitle': '新增白名单游戏',
  'fsBatch.wlGameIdRequired': '请输入游戏ID',
  'fsBatch.wlGameIdPlaceholder': '厂商侧 game_id',
  'fsBatch.wlGameNamePlaceholder': '请输入游戏名称',
  'fsBatch.wlDeleteConfirm': '确定删除该游戏吗？',
  'fsBatch.wlDeleteSuccess': '删除成功',
  'fsBatch.wlAddSuccess': '新增成功',
  'fsBatch.wlOpSuccess': '操作成功',
  'fsBatch.wlOpFailed': '操作失败',
  'chickActivity.continuousCheckin': '连续签到',
  'chickActivity.continuousCheckinDesc': '关停影响：前台连续签到入口不再展示；已累计的连签天数保留，恢复后从记录处继续。',
  'chickActivity.continuousCheckinRule': '规则（固定）：首次签到当日起算；漏签一日从第 1 天重新计算；连签第 N 天领取第 N 天奖励，签满一轮后从第 1 天重新循环；每天最多签一次。现金奖励需完成「流水倍数」要求后方可提现（无独立开关）。',
  'chickActivity.continuousTargetDay': '目标连签天数',
  'chickActivity.dayUnit': '天',
  'chickActivity.coupon': '参与券',
  'chickActivity.couponTemplate': '券模板',
  'chickActivity.selectCouponTemplate': '选择券模板',
  'chickActivity.depositCheckinV2': '存款签到（多维度 · 多奖励类型）',
  'chickActivity.statMetric': '统计维度',
  'chickActivity.byAmount': '按金额',
  'chickActivity.byCount': '按笔数',
  'chickActivity.byAmountHint': '按金额维度：区间按累计存款金额划档。',
  'chickActivity.byCountHint': '按笔数维度：区间按累计存款笔数划档；奖励基数仍为累计存款金额。',
  'chickActivity.cycleSpan': '周期时长',
  'chickActivity.rewardTypesMulti': '奖励类型（可多选，至少启用一项）',
  'chickActivity.v2Formula': '现金/积分：奖励总额 = 本轮累计存款金额 × 区间「{span}日奖励总比例」→ 按 D1–D{span} 曲线拆分（合计=100%）；参与券：每档配置「券模板 + 总数量」→ 按数量曲线拆分（合计=总数量，取整）。',
  'chickActivity.v2FormulaNote': '金额截断：保留 2 位小数，第 3 位直接截取；比例支持 1 位小数。最高档可配置「上限」（仅最高档生效，参与券无上限设置）。再次充值升档 → 从新档位第 1 天重新开始一轮（当天不能重复签）；签满一轮后下一笔充值重新开始新一轮。',
  'chickActivity.tierRangeTitle': '区间设置（现金/积分/参与券共用同一套存款区间）',
  'chickActivity.depositAmountRange': '存款金额区间',
  'chickActivity.depositCountRange': '存款笔数区间',
  'chickActivity.amountUnit': '金额',
  'chickActivity.countUnit': '笔',
  'chickActivity.noUpperLimit': '无上限（-1）',
  'chickActivity.depositAmount': '存款金额',
  'chickActivity.depositCount': '存款笔数',
  'chickActivity.tierRange': '区间',
  'chickActivity.thresholdMin': '门槛（金额，达标=当日第一笔 ≥ 门槛）',
  'chickActivity.baseCapCash': '现金计算基数上限（金额）',
  'chickActivity.baseCapPoints': '积分计算基数上限（金额）',
  'chickActivity.baseCapHint': '发奖基数 = min(当日第一笔存款, 上限)；判档不受上限影响；留空 = 不封顶。例：充 100 万、上限 1 万 → 按 1 万计算。',
  'chickActivity.dailyRatioCurveTitle': ' - 按连续签到天数的每日比例（%，作用于当日第一笔存款金额；每天独立设置，无需合计=100%）',
  'chickActivity.dailyRatioExample': '示例：某档 D3 比例为 10%，用户当日第一笔充值 150 → 该档当天到账 = 150 × 10% = 15（多档同时达标时各档叠加发放）。',
  'chickActivity.cycleSpanHintV3': '周期 = 每个档位「一次连签的最大天数」：某档连续达标超过周期天数后回到 D1 重新循环；各档位独立计数，断签（当日未达该档门槛或未签到）该档归零、他档不受影响。',
  'chickActivity.v3Formula': '每天只取「当日第一笔存款金额」判档，一天只能签到一次（签到时一次结算全部档位）；第一笔 ≥ 哪些档门槛，那些档全部达成：各档连签天数 +1，并按各档「该天比例 × min(第一笔, 基数上限)」叠加发放现金/积分、按各档该天曲线发放参与券。',
  'chickActivity.v3FormulaNote': '当日未达某档门槛（或当天没签到）→ 该档连签归零、从 D1 重来，其他达标档不受影响。金额截断：保留 2 位小数，第 3 位直接截取；积分取整。',
  'chickActivity.tierRangeTitleV3': '档位门槛设置（现金/积分/参与券共用；最低档 ≥1、各档递增，达门槛即达成可叠加）',
  'chickActivity.wagerMultipleHint': '需求流水 = 该档奖励金额 × 倍数（全部游戏、无期限）；0/空 = 无流水要求',
  'chickActivity.couponCurveTitleV3': '参与券发放曲线（按该档连签第 D 天发放张数；总数量仅配置校验，断签重来照曲线从 D1 重发，不做累计封顶）',
  'chickActivity.v3FootNote': '新增/删除档位会同步影响所有已启用奖励类型的曲线行；不同币种的档位与曲线互不影响；档位名称是连签状态的关联键，上线后改名会使该档已有连签重新计数。',
  'chickActivity.totalRatioPercent': '奖励总比例(%)',
  'chickActivity.highestTierCap': '最高档上限',
  'chickActivity.onlyHighestTier': '仅最高档可填',
  'chickActivity.curveTotal': '合计',
  'chickActivity.splitCurveTitle': '拆分曲线（合计=100%）',
  'chickActivity.couponCurveTitle': '参与券发放曲线（按数量拆分，取整，合计需=总数量）',
  'chickActivity.couponTotalQty': '总数量',
  'chickActivity.typeConfigSuffix': '配置',
  'chickActivity.cashWagerEnable': '启用流水限制（提现前需完成指定倍数流水）',
  'chickActivity.wagerBase': '流水计算基数',
  'chickActivity.wagerBaseReward': '仅奖励金额',
  'chickActivity.wagerBaseRewardDeposit': '奖励金额+存款金额',
  'chickActivity.wagerScope': '流水统计范围',
  'chickActivity.wagerScopeAll': '全部游戏',
  'chickActivity.wagerScopeSports': '仅体育',
  'chickActivity.wagerScopeLive': '仅真人',
  'chickActivity.wagerScopeSlots': '仅电子',
  'chickActivity.wagerDeadline': '流水完成期限（天）',
  'chickActivity.wagerMultipleTimes': '流水倍数（倍）',
  'chickActivity.wagerNote': '说明',
  'chickActivity.wagerFormula': '需求流水 = 该档奖励金额 × 倍数',
  'chickActivity.v2FootNote': '新增/删除区间会同步影响所有已启用奖励类型的曲线行；不同币种的区间与曲线互不影响；切换「统计维度/周期/奖励类型」不会清空已填数值。',
  'chickActivity.applyScope': '适用游戏品牌范围',
  'chickActivity.allBrands': '全部品牌',
  'chickActivity.allGamesOfBrand': '该品牌全部游戏',
  'chickActivity.specificGames': '指定游戏',
  'chickActivity.selectGamesPlaceholder': '搜索并选择游戏',
  'chickActivity.scopeHint': '选「指定游戏」后，仅所选游戏的投注额计入本里程碑统计；品牌与单一游戏只能择一。',
  'chickActivity.scopeInherit': '继承默认',
  'chickActivity.scopeOverride': '单独覆盖',
  'chickActivity.defaultScopeTitle': '适用范围（默认值，新增档位自动继承，可按档位单独覆盖）',
  'chickActivity.tierScopeTitle': '档位适用游戏品牌范围',
  'chickActivity.tierScopeHint': '继承默认时跟随上方模块级范围；单独覆盖仅影响本档位。',
  'chickActivity.currentDefault': '当前默认',
  'activity.chickActivity.report.continuousClaimCount': '连续签到领取人数',
  'activity.chickActivity.report.continuousCash': '连续签到发放现金',
  'activity.chickActivity.report.continuousPoints': '连续签到领取积分',
  'activity.chickActivity.report.continuousCoupon': '连续签到参与券(张)',
  'activity.chickActivity.report.v2ClaimCount': '存款签到领取人数',
  'activity.chickActivity.report.v2Cash': '存款签到发放现金',
  'activity.chickActivity.report.v2Points': '存款签到领取积分',
  'activity.chickActivity.report.v2Coupon': '存款签到参与券(张)',
  'chickActivity.allGamesLabel': '全部游戏',
  'chickActivity.andMoreItems': '等{n}项',
  'chickActivity.scopeTreeHint': '按「分类 → 平台 → 游戏」三层勾选，不选则默认全部游戏',
  'chickActivity.pickGames': '选游戏',
  'chickActivity.collapseGames': '收起游戏',
  'chickActivity.selectedGamesCount': '已选 {n} 款',
  'chickActivity.noGames': '该平台暂无游戏数据',
  'chickActivity.editCopy': '编辑文案',
  'chickActivity.taskNameLabel': '任务名称',
  'chickActivity.taskDescLabel': '任务描述',
  'chickActivity.pickGamesHint': '勾选指定游戏；不勾 = 该平台全部游戏',
  'chickActivity.searchGamePlaceholder': '搜索平台 / 游戏名称',
};

